import { Injectable } from '@angular/core';

import { ConstantsService } from '../../../constants.service';
import { SizeHelperService } from '../../../size-helper.service';
import { StageService } from '../../../stage.service';
import { DataForDisplayingMenuItemsService } from '../../../data-for-displaying-menu-items.service';
import { RailingColorsService } from '../../services/railing-colors.service';
import { ProjectManagerService } from '../../../project-manager.service';
import { HelperLinesService } from '../../../helper-lines.service';
import { Edge } from '../..';
import { InfillsForStairsAndLandingService } from '../../infills/infills-for-stairs-and-landing.service';
import { InfillsService } from '../../infills/infills.service';
import { PostAccentLightsArrangeService } from '../../light/post-accent-lights-arrange.service';
import { RailLightAppendService } from '../../light/rail-light-append.service';

declare const THREE: any;

@Injectable()
export class RailingPostsForStairsService {
  intermediatePost: any;
  intermediateAngledPost: any;
  currentParams: any;
  stairPostsPositions: any = [];
  infills: any = [];
  handrail: any;
  baserail: any;
  railingComponent: any;
  railingComponents: any;
  topRailForAngledPost: boolean;
  compositeOrWoodRailingType: boolean;
  posts: any;
  cornerPost: any;
  stepHieght = this.sizeHelper.INCHToCM(7);
  stepLength = this.sizeHelper.INCHToCM(9);
  stairHandrailTopRight: any;
  stairHandrailTopLeft: any;
  stairHandrailCenterRight: any;
  stairHandrailCenterLeft: any;
  stairHandrailBracketRight: any;
  stairHandrailBracketLeft: any;
  stairHandrailBottomRight: any;
  stairHandrailBottomLeft: any;
  projectType: any;
  stairHandrailResidentialTopRight: any;
  stairHandrailResidentialBottomRight: any;
  stairHandrailResidentialTopLeft: any;
  stairHandrailResidentialBottomLeft: any;
  handrailMaterial: any;
  baserailMaterial: any;
  horizontalCableForDoublePost: any;
  postWidth: number;
  intermediatePostOffset: any;
  handrailForFloor: any;
  stairLength: number;

  constructor(
    private constants: ConstantsService,
    private sizeHelper: SizeHelperService,
    private projectSrvc: ProjectManagerService,
    private stage: StageService,
    private infillsForStairsAndLanding: InfillsForStairsAndLandingService,
    private dataForMenu: DataForDisplayingMenuItemsService,
    private infillsService: InfillsService,
    private railingColorsService: RailingColorsService,
    private postAccentLightsArrangeService: PostAccentLightsArrangeService,
    private helperLinesService: HelperLinesService,
    private railLightAppendService: RailLightAppendService
  ) { }

  setPositionForIntermediatePostsOnStairs(Top, bottom, isLeft): Feeney.IPost[] {
    const result = [];

    const stepHieght = this.sizeHelper.INCHToCM(7),
      stepLength = this.sizeHelper.INCHToCM(9);

    const top = Top.clone();
    top.y = bottom.y;
    let horizontalDistance = top.distanceTo(bottom);

    const numberOfSteps =
      Math.floor((Top.y - bottom.y) / stepHieght + 0.2) - (this.intermediatePostOffset > 0 ? 0 : 1);

    top.y += (horizontalDistance * 7) / 9;
    const offsetVector = new THREE.Vector3(bottom.x - top.x, 0, bottom.z - top.z);
    const railDirection = offsetVector.clone();
    const correctionPositionOnStep = offsetVector.clone().negate();
    const rotationVector = new THREE.Vector3(offsetVector.z, 0, -offsetVector.x);

    top.isLeft = isLeft;
    bottom.isLeft = isLeft;

    if (isLeft) {
      rotationVector.negate();
    }

    const projectType = this.projectSrvc.getProjectType();
    let maxWidth =
      projectType === 'business' ? this.sizeHelper.INCHToCM(60) : this.sizeHelper.INCHToCM(72);
    if (this.currentParams.infill === 'glass') {
      maxWidth = this.sizeHelper.INCHToCM(60);
    }
    if (
      this.currentParams.railingType === 'Steel flat bar' ||
      this.currentParams.railingType === 'Steel round tubular'
    ) {
      maxWidth = this.sizeHelper.INCHToCM(36);
    }

    const horizontalTop = new THREE.Vector3(top.x, 0, top.z);
    const horizontalBottom = new THREE.Vector3(bottom.x, 0, bottom.z);

    horizontalDistance = horizontalBottom.distanceTo(horizontalTop);
    // let horizontalStep: any;
    let numberOfHorizontalSteps: any;
    const horizontalPositions: any = [];
    // let horizontalSetpVector = new THREE.Vector3(bottom.x - top.x, 0, bottom.z - top.z);

    if (horizontalDistance < maxWidth * Math.cos(7 / 9)) {
      this.infillsForStairsAndLanding.addInfillForStairs(
        bottom,
        top,
        this.infills,
        this.railingComponents
      );
    } else {
      const maxNumberOfSteps = Math.floor((maxWidth * Math.cos(7 / 9)) / stepLength);
      let numberOfStepsBetweenPosts = 2;
      for (let i = maxNumberOfSteps; i > 1; i--) {
        if (i >= numberOfStepsBetweenPosts && numberOfSteps % i === 0) {
          numberOfStepsBetweenPosts = i;
          numberOfHorizontalSteps = numberOfSteps / numberOfStepsBetweenPosts - 1;
        }
      }
      if (numberOfStepsBetweenPosts === 2) {
        for (let i = maxNumberOfSteps; i > 1; i--) {
          if (i >= numberOfStepsBetweenPosts && numberOfSteps % i === i - 1) {
            numberOfStepsBetweenPosts = i;
            numberOfHorizontalSteps = Math.floor(numberOfSteps / numberOfStepsBetweenPosts);
          }
        }
      }
      let isPicket =
        (numberOfStepsBetweenPosts * stepLength) / Math.cos(7 / 9) > this.sizeHelper.INCHToCM(36)
          ? true
          : false;
      if (numberOfStepsBetweenPosts === 2 && this.intermediatePostOffset > 0) {
        for (let i = maxNumberOfSteps; i > 1; i--) {
          if (i > numberOfStepsBetweenPosts && numberOfSteps % i === 1) {
            numberOfStepsBetweenPosts = i;
            numberOfHorizontalSteps = Math.floor(numberOfSteps / numberOfStepsBetweenPosts) - 1;
            isPicket =
              ((numberOfStepsBetweenPosts + 1) * stepLength) / Math.cos(7 / 9) >
                this.sizeHelper.INCHToCM(36)
                ? true
                : false;
          }
        }
      }

      top.isPicket = isPicket;
      bottom.isPicket = isPicket;

      for (let i = 0; i < numberOfHorizontalSteps; i++) {
        horizontalPositions[i] = bottom.clone();
        horizontalPositions[i].isLeft = isLeft;
        horizontalPositions[i].isPicket = isPicket;

        for (let j = 0; j < numberOfStepsBetweenPosts * (i + 1); j++) {
          const upVector = new THREE.Vector3(0, stepHieght, 0);
          horizontalPositions[i].add(upVector);
          correctionPositionOnStep.setLength(stepLength);
          horizontalPositions[i].add(correctionPositionOnStep);
        }
      }

      if (numberOfHorizontalSteps > 0) {
        this.infillsForStairsAndLanding.addInfillForStairs(
          horizontalPositions[numberOfHorizontalSteps - 1],
          top,
          this.infills,
          this.railingComponents
        );
        this.infillsForStairsAndLanding.addInfillForStairs(
          bottom,
          horizontalPositions[0],
          this.infills,
          this.railingComponents
        );
        for (let i = 0; i < numberOfHorizontalSteps - 1; i++) {
          this.infillsForStairsAndLanding.addInfillForStairs(
            horizontalPositions[i],
            horizontalPositions[i + 1],
            this.infills,
            this.railingComponents
          );
        }
        for (let i = 0; i < numberOfHorizontalSteps; i++) {
          horizontalPositions[i].vector = rotationVector;
          horizontalPositions[i].isLeft = isLeft;
          horizontalPositions[i].isPicket = isPicket;
          horizontalPositions[i].direction = railDirection;
          horizontalPositions[i].edge = new Edge(Top, bottom);

          if (
            this.currentParams.stairHandrail !== '' &&
            this.currentParams.stairHandrail !== 'top150'
          ) {
            this.addStairHandrailBracket(horizontalPositions[i], isLeft);
          }
          this.stairPostsPositions.push(horizontalPositions[i]);
          result.push(horizontalPositions[i]);
        }
      } else {
        this.infillsForStairsAndLanding.addInfillForStairs(
          bottom,
          top,
          this.infills,
          this.railingComponents
        );
      }
    }

    return result;
  }

  addStairHandrailBracket(position, isLeft) {
    let stairHandrailBracket = this.stairHandrailBracketRight.clone();

    const rotationVector = new THREE.Vector3(-position.vector.z, 0, position.vector.x);

    if (isLeft) {
      stairHandrailBracket = this.stairHandrailBracketLeft.clone();
      rotationVector.negate();
    }

    stairHandrailBracket.position.set(
      position.x,
      position.y +
      this.sizeHelper.INCHToCM(36) +
      this.stairHandrailCenterLeft.userData.entity.height -
      stairHandrailBracket.userData.entity
        .height /*+ stairHandrailBracket.userData.entity.placementHeight - this.sizeHelper.INCHToCM(+this.intermediatePost.userData.entity.heightGroup - 36)*/,
      position.z
    );

    const offsetVector = position.vector.clone().negate();
    let offset =
      (stairHandrailBracket.userData.entity.width + this.intermediatePost.userData.entity.width) /
      2;

    if (this.currentParams.postMounting === 'Fascia Bracket Mount') {
      offset =
        (stairHandrailBracket.userData.entity.width + this.intermediatePost.userData.entity.width) /
        2 -
        3.5;
    }
    if (this.currentParams.postMounting === 'Base Mount') {
      offset =
        (stairHandrailBracket.userData.entity.width +
          this.intermediatePost.userData.entity.length) /
        2 -
        3.3;

      if (this.currentParams.railingType === 'Steel round tubular') {
        offset -= 1;
      }
    }
    if (
      this.currentParams.postMounting === 'Fascia Mount' &&
      this.currentParams.railingType === 'Steel flat bar'
    ) {
      offset =
        (stairHandrailBracket.userData.entity.width +
          this.intermediatePost.userData.entity.length) /
        2 -
        1;
    }

    offsetVector.setLength(offset);
    stairHandrailBracket.position.add(offsetVector);

    const norm = new THREE.Vector3(0, 0, 1);
    let angle = rotationVector.angleTo(norm);
    if (rotationVector.x < 0) {
      angle = -rotationVector.angleTo(norm);
    }
    stairHandrailBracket.rotateY(angle);

    this.stage.add(stairHandrailBracket);

    this.infills.push(stairHandrailBracket);

    stairHandrailBracket.children.forEach(ch => (ch.castShadow = true));
  }

  addHandrailAndBaserailForStairs(infills, railingComponent, posts): Feeney.IAddHandrailResult[] {
    const stairs = this.stage.getStairs();

    this.stairLength = this.sizeHelper.INCHToCM(9);

    this.railingComponents = railingComponent;

    this.updateCurrentParams();

    this.projectType = this.projectSrvc.getProjectType();

    this.infills = infills;

    this.horizontalCableForDoublePost =
      this.currentParams.infill === 'horizontalCableBaserail'
        ? this.railingComponents.horizontalCableForDoubleCornerWhithoutBaserail
        : this.railingComponents.horizontalCable;
    this.posts = posts;
    this.railingComponent = railingComponent;
    this.intermediatePost = railingComponent.intermediatePostForStairs;
    this.intermediateAngledPost = railingComponent.intermediateAngledPost;
    this.topRailForAngledPost =
      this.currentParams.topRail === 'Wood 2x4' ||
      this.currentParams.topRail === 'CompositeTop' ||
      this.currentParams.topRail === '200s';
    this.compositeOrWoodRailingType =
      this.currentParams.railingType === 'Composite' || this.currentParams.railingType === 'Wood';

    this.cornerPost = railingComponent.cornerPostForStairs;
    this.handrail = railingComponent.handrailForStairs || railingComponent.handrail;
    this.handrailForFloor = railingComponent.handrail;
    this.handrailMaterial = railingComponent.handrail.children[0].material.clone();

    switch (this.currentParams.railingType) {
      case 'DesignRail': {
        this.postWidth = 6.035;
        break;
      }
      case 'Steel flat bar': {
        this.postWidth = 5.0028;
        break;
      }
      case 'Steel round tubular': {
        this.postWidth = 5.0028;
        break;
      }
      case 'Wood': {
        this.postWidth = this.intermediatePost.userData.entity.width - 0.25;
        break;
      }
      default: {
        // postWidth is the post's actual column; width is the base-plate
        // footprint, which is far wider on base-mounted posts
        this.postWidth =
          +this.intermediatePost.userData.entity.postWidth ||
          this.intermediatePost.userData.entity.width;
      }
    }

    this.intermediatePostOffset = +this.intermediatePost.userData.entity.offset;
    if (this.currentParams.railingType === 'Wood' && this.intermediatePostOffset < 0) {
      this.intermediatePostOffset += 1;
    }

    if (railingComponent.stairHandrailBottomLeft) {
      this.stairHandrailBottomLeft = railingComponent.stairHandrailBottomLeft;
      this.stairHandrailBottomRight = railingComponent.stairHandrailBottomRight;
      this.stairHandrailBracketLeft = railingComponent.stairHandrailBracketLeft;
      this.stairHandrailBracketRight = railingComponent.stairHandrailBracketRight;
      this.stairHandrailCenterLeft = railingComponent.stairHandrailCenterLeft;
      this.stairHandrailCenterRight = railingComponent.stairHandrailCenterRight;
      this.stairHandrailTopLeft = railingComponent.stairHandrailTopLeft;
      this.stairHandrailTopRight = railingComponent.stairHandrailTopRight;
      this.stairHandrailResidentialBottomLeft = railingComponent.stairHandrailResidentialBottomLeft;
      this.stairHandrailResidentialBottomRight =
        railingComponent.stairHandrailResidentialBottomRight;
      this.stairHandrailResidentialTopLeft = railingComponent.stairHandrailResidentialTopLeft;
      this.stairHandrailResidentialTopRight = railingComponent.stairHandrailResidentialTopRight;
    }
    this.railingColorsService.setExistingColor(this.stairHandrailBracketLeft, 'Stair Handrail');
    this.railingColorsService.setExistingColor(this.stairHandrailBracketRight, 'Stair Handrail');

    let result: Feeney.IAddHandrailResult[] = [];

    for (let i = 0; i < stairs.length; i++) {
      switch (stairs[i].userData.type) {
        case 'Straight':
          {
            result = result.concat(this.addHandrailAndBaserailForStraightStairs(stairs[i]));
          }
          break;
        case 'LandingStraight':
          {
            this.addHandrailAndBaserailForStairsLandingStraight(stairs[i]);
          }
          break;
        case 'LandingLeft':
          {
            result = result.concat(this.addHandrailAndBaserailForStairsLandingLeft(stairs[i]));
          }
          break;
        case 'LandingRight':
          {
            result = result.concat(this.addHandrailAndBaserailForStairsLandingRight(stairs[i]));
          }
          break;
        case 'LandingBothSides':
          {
            result = result.concat(this.addHandrailAndBaserailForStairsLandingBothSides(stairs[i]));
          }
          break;
      }
    }

    for (let i = 0; i < this.stairPostsPositions.length; i++) {
      const postPosition = this.stairPostsPositions[i];
      const postModel =
        this.compositeOrWoodRailingType && this.topRailForAngledPost && !postPosition.isFrontLanding
          ? this.intermediateAngledPost
          : this.intermediatePost;
      const post = postPosition.corner
        ? this.addCornerPost(postPosition, postPosition.vector)
        : this.addTerminationPost(postPosition, postPosition.vector, postModel);
      this.postAccentLightsArrangeService.addForStairs(post, postPosition);
    }

    const rails = result.map(item => item.rails).reduce((p, c) => p.concat(c), []);

    rails.forEach(r => this.railLightAppendService.addLightToRail(r));

    this.stairPostsPositions = [];

    return result;
  }

  private showHorizontalCable(object, position) {
    // cases for showing horizontal calbe
    // between double post
    // http://146.185.164.175:8080/browse/FR-744
    return (
      object.userData.entity.cornerType === 'Double' &&
      (this.currentParams.infill === 'horizontalCableBaserail' ||
        this.currentParams.infill === 'horizontalCable') &&
      !position.is45 &&
      !position.is135 &&
      !(
        this.currentParams.railingType === 'DesignRail' &&
        (this.currentParams.topRail === '150s' || this.currentParams.topRail === '100s')
      )
    );
  }

  addCornerPost(position, vector) {
    let obj;

    obj = this.cornerPost.clone();

    obj.children.forEach(ch => (ch.castShadow = ch.name === 'Post'));

    obj.visible = true;

    const postPosition = new THREE.Vector3(
      position.x,
      position.y + this.cornerPost.userData.entity.height / 2,
      position.z
    );
    const floorPoint = position.clone();

    const offsetForFloorPoint =
      -(this.sizeHelper.INCHToCM(2.5) + this.intermediatePostOffset) / Math.cos(Math.PI / 4);
    const vectorForFloorPoint = vector.clone();
    vectorForFloorPoint.setLength(offsetForFloorPoint);
    floorPoint.add(vectorForFloorPoint);

    postPosition.y += this.cornerPost.userData.entity.placementHeight;

    let offset =
      this.sizeHelper.INCHToCM(2.5) / Math.cos(Math.PI / 4) +
      +this.cornerPost.userData.entity.offset -
      (this.sizeHelper.INCHToCM(2.5) + this.intermediatePostOffset) / Math.cos(Math.PI / 4);

    if (+this.cornerPost.userData.entity.offset < 0) {
      offset =
        -(
          this.sizeHelper.INCHToCM(2.5) / Math.cos(Math.PI / 4) +
          +this.cornerPost.userData.entity.offset
        ) -
        (this.sizeHelper.INCHToCM(2.5) + this.intermediatePostOffset) / Math.cos(Math.PI / 4);
      if (this.currentParams.railingType === 'Wood') {
        offset = 11;
      }
    }

    vector.setLength(offset);

    postPosition.add(vector);

    obj.position.set(postPosition.x, postPosition.y, postPosition.z);

    this.railingColorsService.setExistingColor(obj, 'Post', 'Post');

    const norm = new THREE.Vector3(0, 0, 1);
    let angle = vector.angleTo(norm);

    if (vector.x < 0) {
      angle = -vector.angleTo(norm);
    }

    obj.rotation.y = angle + Math.PI / 4;

    position.rotation = obj.rotation.y;

    if (
      this.currentParams.railingType === 'DesignRail' &&
      this.currentParams.postMounting === 'Fascia Bracket Mount'
    ) {
      obj.rotation.y -= Math.PI / 2;
      position.rotation = obj.rotation.y;
    }

    this.stage.add(obj);
    this.posts.push(obj);

    if (this.showHorizontalCable(obj, position)) {
      const pointToNextFloorPoint = new THREE.Vector3(
        position.nextFloorPoint.x - position.x,
        0,
        position.nextFloorPoint.z - position.z
      );
      const pointToPreviousFloorPoint = new THREE.Vector3(
        position.previousFloorPoint.x - position.x,
        0,
        position.previousFloorPoint.z - position.z
      );
      const firstPoint = position.clone();
      const secondPoint = position.clone();
      const innerOffset = obj.userData.entity.innerOffset ? obj.userData.entity.innerOffset : 0;

      pointToNextFloorPoint.setLength(innerOffset);
      pointToPreviousFloorPoint.setLength(innerOffset);

      firstPoint.add(pointToNextFloorPoint);
      secondPoint.add(pointToPreviousFloorPoint);

      // const height = this.horizontalCableForDoublePost.userData.entity.placementHeight
      // + this.horizontalCableForDoublePost.userData.entity.height / 2
      // + position.y;
      // const horizontalCableForDoublePost = this.horizontalCableForDoublePost.clone();
      // const length = firstPoint.distanceTo(secondPoint);

      // horizontalCableForDoublePost.visible = true;
      // horizontalCableForDoublePost.scale.x = length / this.horizontalCableForDoublePost.userData.entity.length;
      // horizontalCableForDoublePost.position.set((firstPoint.x + secondPoint.x) / 2, height, (firstPoint.z + secondPoint.z) / 2);
      // horizontalCableForDoublePost.rotation.y = obj.rotation.y - Math.PI / 4;

      // if (obj.userData.entity.mountType === 'Fascia Bracket Mount') {
      //   horizontalCableForDoublePost.rotation.y += Math.PI / 2;
      // }

      // this.stage.add(horizontalCableForDoublePost);
      // this.posts.push(horizontalCableForDoublePost);

      if (this.currentParams.infill === 'horizontalCable') {
        const height =
          this.horizontalCableForDoublePost.userData.entity.placementHeight +
          this.horizontalCableForDoublePost.userData.entity.height / 2 +
          position.y;
        const horizontalCableForDoublePost = this.horizontalCableForDoublePost.clone();
        const length = firstPoint.distanceTo(secondPoint);

        horizontalCableForDoublePost.visible = true;
        horizontalCableForDoublePost.scale.x =
          length / this.horizontalCableForDoublePost.userData.entity.length;
        horizontalCableForDoublePost.position.set(
          (firstPoint.x + secondPoint.x) / 2,
          height,
          (firstPoint.z + secondPoint.z) / 2
        );
        horizontalCableForDoublePost.rotation.y = obj.rotation.y - Math.PI / 4;

        if (obj.userData.entity.mountType === 'Fascia Bracket Mount') {
          horizontalCableForDoublePost.rotation.y += Math.PI / 2;
        }

        this.stage.add(horizontalCableForDoublePost);
        this.posts.push(horizontalCableForDoublePost);
      }

      if (this.currentParams.infill === 'horizontalCableBaserail') {
        let count;
        switch (this.currentParams.railingHeight) {
          case '36':
            count = 10;
            break;
          case '39':
            count = 11;
            break;
          case '42':
            count = 12;
            break;
        }
        const height = 5.54 + position.y;
        const length = firstPoint.distanceTo(secondPoint);
        const gap = 7.6;
        for (let i = 0; i < count; i++) {
          const horizontalCableForDoublePost = this.railingComponent.singleHorizontalCable.clone();

          horizontalCableForDoublePost.visible = true;
          horizontalCableForDoublePost.scale.x =
            length / this.railingComponent.singleHorizontalCable.userData.entity.width;
          horizontalCableForDoublePost.position.set(
            (firstPoint.x + secondPoint.x) / 2,
            height + gap * (i + 1),
            (firstPoint.z + secondPoint.z) / 2
          );
          horizontalCableForDoublePost.rotation.y = obj.rotation.y - Math.PI / 4;

          if (obj.userData.entity.mountType === 'Fascia Bracket Mount') {
            horizontalCableForDoublePost.rotation.y += Math.PI / 2;
          }

          this.stage.add(horizontalCableForDoublePost);
          this.posts.push(horizontalCableForDoublePost);
        }
      }
    }
    return obj;
  }

  addTerminationPost(position, vector, intermediatePost) {
    let obj;

    obj = intermediatePost.clone();

    obj.name = 'PostContainer';

    obj.children.forEach(ch => (ch.castShadow = ch.name === 'Post'));

    obj.userData.onStairs = true;

    obj.visible = true;

    obj.position.set(
      position.x,
      position.y +
      (intermediatePost.userData.entity ? intermediatePost.userData.entity.height / 2 : 45),
      position.z
    );

    obj.position.y += intermediatePost.userData.entity.placementHeight || 0;

    this.railingColorsService.setExistingColor(obj, 'Post', 'Post');

    const norm = new THREE.Vector3(0, 0, 1);
    let angle = vector.angleTo(norm);

    if (vector.x < 0) {
      // norm.negate();
      angle = -vector.angleTo(norm);
    }

    obj.children.forEach(ch => (ch.rotation.y = angle));

    position.rotation = angle;

    // use posts with angled top for
    // only inclined handrails
    if (!position.isFrontLanding) {
      if (
        this.compositeOrWoodRailingType &&
        this.topRailForAngledPost &&
        position.isLeft === false
      ) {
        // composite and wood posts are angled,
        // and using one model for both left and
        // right sides (that are not symmetrical to both of them),
        // requires to turn one of them
        // by 180 degrees;
        angle += Math.PI;
        obj.children.forEach(ch => (ch.rotation.y = angle));
        position.rotation = angle;
        const bolts = obj.getObjectByName('Bolts');
        if (bolts) {
          bolts.rotation.y = angle + Math.PI;
        }
      }

      if (this.currentParams.railingType === 'Composite' && this.topRailForAngledPost) {
        // angled posts have slope on top
        // need to move up to the middle
        // of that slope
        obj.position.y += 5;
      }

      if (this.currentParams.railingType === 'Wood' && this.topRailForAngledPost) {
        // angled posts have slope on top
        // need to move up to the middle
        // of that slope
        obj.position.y += 2;
      }
      if (
        (this.currentParams.railingType === 'Wood' ||
          this.currentParams.railingType === 'Composite' ||
          this.currentParams.railingType === 'DesignRail') &&
        this.currentParams.topRailForStairs === '150s'
      ) {
        obj.scale.y = 1.09;
        obj.position.y += 3.75;
      } else if (
        this.currentParams.railingType === 'DesignRail' &&
        this.currentParams.topRailForStairs === '150s'
      ) {
        obj.scale.y = 1.07;
        obj.position.y += 3;
      }
      // CompositeBetween
      if (this.compositeOrWoodRailingType && this.currentParams.topRail === 'CompositeBetween') {
        // for CompositeBetween type of topRail
        // make post slightly higher
        obj.scale.y = 1.12;
        obj.position.y += 5;
      }
    }

    this.stage.add(obj);
    this.posts.push(obj);
    return obj;
  }

  addHandrailAndBaserailForStraightStairs(stairs): Feeney.IAddHandrailResult {
    this.helperLinesService.removeTestMarkers();
    const top = stairs.children.filter(function (item) {
      return item.name === 'Top';
    });
    const bottom = stairs.children.filter(function (item) {
      return item.name === 'Bottom';
    });

    let needRight = true;
    let countOfStepsRight = 0;
    let rightCorrection = null;

    let needLeft = true;
    let countOfStepsLeft = 0;
    let leftCorrection = null;

    const dist = top[0].position.clone().setY(0).distanceTo(bottom[0].position.clone().setY(0));
    const prev = new THREE.Vector3(
      stairs.userData.config.prevPoint.x,
      0,
      stairs.userData.config.prevPoint.y
    );
    const next = new THREE.Vector3(
      stairs.userData.config.nextPoint.x,
      0,
      stairs.userData.config.nextPoint.y
    );
    const first = new THREE.Vector3(
      stairs.userData.config.firstPoint.x,
      0,
      stairs.userData.config.firstPoint.y
    );
    const second = new THREE.Vector3(
      stairs.userData.config.secondPoint.x,
      0,
      stairs.userData.config.secondPoint.y
    );

    const prevEdgeLength = prev.distanceTo(first);
    const edgeLength = first.distanceTo(second);

    if (stairs.userData.config.prevPoint.superstructureType === 'wall') {
      if (
        stairs.userData.config.firstPoint.distance <
        stairs.userData.config.firstPoint.width / 2 + 1
      ) {
        if (
          stairs.userData.config.prevPoint.distance + stairs.userData.config.prevPoint.width / 2 >
          prevEdgeLength + dist
        ) {
          needRight = false;
        } else if (
          stairs.userData.config.prevPoint.distance + stairs.userData.config.prevPoint.width / 2 >
          prevEdgeLength + this.stairLength
        ) {
          countOfStepsRight = Math.floor(
            (stairs.userData.config.prevPoint.distance +
              stairs.userData.config.prevPoint.width / 2 -
              prevEdgeLength) /
            this.stairLength
          );
          rightCorrection = bottom[0].position
            .clone()
            .setY(0)
            .sub(top[0].position.clone().setY(0))
            .setLength(this.stairLength * countOfStepsRight)
            .add(new THREE.Vector3(0, (-this.stairLength / 9) * 7 * countOfStepsRight));
        }
      }
    }
    if (stairs.userData.config.secondPoint.superstructureType === 'wall') {
      if (
        stairs.userData.config.firstPoint.distance + stairs.userData.config.firstPoint.width / 2 >
        edgeLength - 1
      ) {
        if (
          stairs.userData.config.secondPoint.distance -
          stairs.userData.config.secondPoint.width / 2 <
          -dist
        ) {
          needLeft = false;
        } else if (
          stairs.userData.config.secondPoint.distance -
          stairs.userData.config.secondPoint.width / 2 <
          -this.stairLength
        ) {
          countOfStepsLeft = Math.floor(
            Math.abs(
              stairs.userData.config.secondPoint.distance -
              stairs.userData.config.secondPoint.width / 2
            ) / this.stairLength
          );
          leftCorrection = bottom[0].position
            .clone()
            .setY(0)
            .sub(top[0].position.clone().setY(0))
            .setLength(this.stairLength * countOfStepsLeft)
            .add(new THREE.Vector3(0, (-this.stairLength / 9) * 7 * countOfStepsLeft));
        }
      }
    }
    let direction = new THREE.Vector3(
      bottom[0].position.x - top[0].position.x,
      0,
      bottom[0].position.z - top[0].position.z
    );
    let woodCorrection = direction.clone().negate().setLength(this.intermediatePost.userData.entity.width);
    const railDirection = direction.clone();
    const normal = direction.clone();
    normal.normalize();
    const nr = normal.clone();
    nr.setLength(11.52);
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    const leftTop = top[0].position.clone(),
      rightTop = top[0].position.clone(),
      leftBottom = bottom[0].position.clone(),
      rightBottom = bottom[0].position.clone();

    leftBottom.add(direction);
    leftTop.add(direction);
    direction.negate();
    rightBottom.add(direction);
    rightTop.add(direction);

    direction.setLength(1);

    rightBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    leftBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    leftBottom.y += (14.6 + 2.54) / 2;
    rightBottom.y += (14.6 + 2.54) / 2;

    const leftTopPostPosition = stairs.userData.config.firstPoint.secondPostPosition;
    const rightTopPostPosition = stairs.userData.config.firstPoint.firstPostPosition;
    if (stairs.needCorrection) {
      rightTopPostPosition.add(woodCorrection);
    }
    leftTopPostPosition.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    rightTopPostPosition.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    leftTopPostPosition.direction = rightTopPostPosition.direction = railDirection;

    leftTopPostPosition.isConnectedWithHorizontal = false;
    leftBottom.isConnectedWithHorizontal = false;
    rightTopPostPosition.isConnectedWithHorizontal = false;
    rightBottom.isConnectedWithHorizontal = false;

    leftTopPostPosition.isConnectedWithNonHorizontal = true;
    leftBottom.isConnectedWithNonHorizontal = true;
    rightTopPostPosition.isConnectedWithNonHorizontal = true;
    rightBottom.isConnectedWithNonHorizontal = true;

    leftTopPostPosition.needHalfAngle = true;
    leftBottom.needHalfAngle = false;
    rightTopPostPosition.needHalfAngle = true;
    rightBottom.needHalfAngle = false;

    const firstLeftTopPoint = leftTopPostPosition.clone();
    const secondLeftTopPoint = leftTopPostPosition.clone();
    const firstRightTopPoint = rightTopPostPosition.clone();
    const secondRightTopPoint = rightTopPostPosition.clone();

    const leftToRight = new THREE.Vector3(
      rightTop.x - leftTop.x,
      0,
      rightTop.z - leftTop.z
    );
    const rightToLeft = new THREE.Vector3(
      leftTop.x - rightTop.x,
      0,
      leftTop.z - rightTop.z
    );
    leftToRight.setLength(this.handrailForFloor.userData.entity.width / 2);
    rightToLeft.setLength(this.handrailForFloor.userData.entity.width / 2);
    firstLeftTopPoint.add(rightToLeft);
    firstRightTopPoint.add(leftToRight);

    leftTopPostPosition.isTop = true;
    leftTopPostPosition.firstPost = firstLeftTopPoint;
    leftTopPostPosition.secondPost = secondLeftTopPoint;
    rightTopPostPosition.isTop = true;
    rightTopPostPosition.firstPost = firstRightTopPoint;
    rightTopPostPosition.secondPost = secondRightTopPoint;


    let result: Array<Feeney.Rail.IRail> = [];
    let rightEdgePosts = [];
    let leftEdgePosts = [];

    if (needLeft) {
      if (countOfStepsLeft) {
        leftTopPostPosition.add(leftCorrection);
        leftTopPostPosition.firstPost.add(leftCorrection);
        leftTopPostPosition.secondPost.add(leftCorrection);

        // leftTopPostPosition.isTop = false;
        leftEdgePosts.push(leftTopPostPosition);
        this.stairPostsPositions.push(leftTopPostPosition);
      }
      result = result.concat(
        this.addNonHorizontalHandrailAndBaserail(leftTopPostPosition, leftBottom, true)
      );
      leftEdgePosts = leftEdgePosts.concat(
        this.setPositionForIntermediatePostsOnStairs(leftTopPostPosition, leftBottom, true)
      );
    }
    if (needRight) {
      if (countOfStepsRight) {
        rightTopPostPosition.add(rightCorrection);
        rightTopPostPosition.firstPost.add(rightCorrection);
        rightTopPostPosition.secondPost.add(rightCorrection);
        // rightTopPostPosition.isTop = false;
        rightEdgePosts.push(rightTopPostPosition);
        this.stairPostsPositions.push(rightTopPostPosition);
      }
      result = result.concat(
        this.addNonHorizontalHandrailAndBaserail(rightTopPostPosition, rightBottom, false)
      );
      rightEdgePosts = rightEdgePosts.concat(
        this.setPositionForIntermediatePostsOnStairs(rightTopPostPosition, rightBottom, false)
      );
    }

    const LeftBottom = leftBottom.clone();
    const RightBottom = rightBottom.clone();
    const dir = new THREE.Vector3(
      leftTop.x - leftBottom.x,
      leftTop.y - leftBottom.y,
      leftTop.z - leftBottom.z
    );
    dir.setLength(20);
    LeftBottom.add(dir);
    RightBottom.add(dir);

    leftBottom.isLeft = true;
    rightBottom.isLeft = false;
    leftBottom.direction = rightBottom.direction = railDirection;
    leftBottom.isBottom = rightBottom.isBottom = true;
    leftBottom.isTerminationPost = rightBottom.isTerminationPost = true;

    if (needLeft) {
      leftEdgePosts.push(leftBottom);
      this.stairPostsPositions.push(leftBottom);
    }
    if (needRight) {
      rightEdgePosts.push(rightBottom);
      this.stairPostsPositions.push(rightBottom);
    }
    // this.stairPostsPositions.push(leftBottom, rightBottom);

    const right: Feeney.IEdgePosts = {
      edge: new Edge(rightTopPostPosition, rightBottom),
      postData: rightEdgePosts
    };

    const left: Feeney.IEdgePosts = {
      edge: new Edge(leftTopPostPosition, leftBottom),
      postData: leftEdgePosts
    };

    return {
      rails: result,
      edgePosts: [right, left]
    };
  }

  addHandrailAndBaserailForStairsLandingStraight(stairs) {
    const top = stairs.children.filter(function (item) {
      return item.name === 'Top';
    });
    const bottom = stairs.children.filter(function (item) {
      return item.name === 'Bottom';
    });
    const landing = stairs.children.filter(function (item) {
      return item.name === 'Landing';
    });

    let direction = new THREE.Vector3(
      bottom[0].position.x - top[0].position.x,
      0,
      bottom[0].position.z - top[0].position.z
    );

    let woodCorrection = direction.clone().negate().setLength(this.intermediatePost.userData.entity.width);
    const railDirection = direction.clone();
    const normal = direction.clone();
    normal.normalize();
    const nr = normal.clone();
    nr.setLength(11.52);
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    const leftTop = top[0].position.clone(),
      rightTop = top[0].position.clone(),
      leftBottom = bottom[0].position.clone(),
      rightBottom = bottom[0].position.clone(),
      leftFrontLanding = landing[0].position.clone(),
      rightFrontLanding = landing[0].position.clone(),
      leftBackLanding = landing[0].position.clone(),
      rightBackLanding = landing[0].position.clone();

    leftBottom.add(direction);
    leftTop.add(direction);
    leftBackLanding.add(direction);
    leftFrontLanding.add(direction);
    direction.negate();
    rightBottom.add(direction);
    rightTop.add(direction);
    rightBackLanding.add(direction);
    rightFrontLanding.add(direction);

    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - 3.016);

    leftBackLanding.add(direction);
    rightBackLanding.add(direction);
    direction.negate();
    if (this.intermediatePostOffset > 0) {
      direction.setLength(
        stairs.userData.config.width / 2 -
        this.sizeHelper.INCHToCM(2.5) -
        this.intermediatePostOffset -
        4
      );
      if (this.currentParams.railingType === 'Composite') {
        direction.setLength(direction.length() + 4);
      }
    } else {
      direction.setLength(stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(4.5)); // + this.intermediatePostOffset - 4);
    }
    rightFrontLanding.add(direction);
    leftFrontLanding.add(direction);

    direction = new THREE.Vector3(-direction.z, 0, direction.x);

    leftBackLanding.y += (17.78 + 2.54) / 2;
    rightBackLanding.y += (17.78 + 2.54) / 2;
    leftFrontLanding.y += (17.78 + 2.54) / 2;
    rightFrontLanding.y += (17.78 + 2.54) / 2;

    const leftTopPostPosition = stairs.userData.config.firstPoint.secondPostPosition;
    const rightTopPostPosition = stairs.userData.config.firstPoint.firstPostPosition;

    leftTopPostPosition.isConnectedWithHorizontal = false;
    leftFrontLanding.isConnectedWithHorizontal = true;
    rightTopPostPosition.isConnectedWithHorizontal = false;
    rightFrontLanding.isConnectedWithHorizontal = true;
    leftBackLanding.isConnectedWithHorizontal = true;
    rightBackLanding.isConnectedWithHorizontal = true;

    leftTopPostPosition.isConnectedWithNonHorizontal = true;
    leftFrontLanding.isConnectedWithNonHorizontal = true;
    rightTopPostPosition.isConnectedWithNonHorizontal = true;
    rightFrontLanding.isConnectedWithNonHorizontal = true;
    leftBackLanding.isConnectedWithNonHorizontal = false;
    rightBackLanding.isConnectedWithNonHorizontal = false;

    leftFrontLanding.isLowerPoint = true;
    rightFrontLanding.isLowerPoint = true;

    this.addNonHorizontalHandrailAndBaserail(leftTopPostPosition, leftFrontLanding, true, false);
    this.addNonHorizontalHandrailAndBaserail(rightTopPostPosition, rightFrontLanding, false, false);
    this.setPositionForIntermediatePostsOnStairs(leftTopPostPosition, leftFrontLanding, true);
    this.setPositionForIntermediatePostsOnStairs(rightTopPostPosition, rightFrontLanding, false);
    this.infillsService.addHandrailAndBaserail(
      null,
      rightBackLanding,
      rightFrontLanding,
      this.railingComponent,
      null,
      null,
      null,
      null
    );
    this.infillsService.addHandrailAndBaserail(
      null,
      leftBackLanding,
      leftFrontLanding,
      this.railingComponent,
      null,
      null,
      null
    );

    const LeftBottom = leftBottom.clone();
    const RightBottom = rightBottom.clone();
    const dir = new THREE.Vector3(
      leftTop.x - leftBottom.x,
      leftTop.y - leftBottom.y,
      leftTop.z - leftBottom.z
    );
    dir.setLength(5);
    LeftBottom.add(dir);
    RightBottom.add(dir);

    this.infillsForStairsAndLanding.addInfillForLanding(
      rightBackLanding,
      rightFrontLanding,
      this.infills,
      this.railingComponents
    );
    this.infillsForStairsAndLanding.addInfillForLanding(
      leftBackLanding,
      leftFrontLanding,
      this.infills,
      this.railingComponents
    );

    direction.setLength(1);
    direction.negate();

    leftBackLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    leftFrontLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    rightFrontLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    rightBackLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    leftBackLanding.isFrontLanding = true;
    rightBackLanding.isFrontLanding = true;
    leftFrontLanding.isFrontLanding = true;
    rightFrontLanding.isFrontLanding = true;
    leftBackLanding.isBottom = rightBackLanding.isBottom = true;
    leftBackLanding.direction = rightBackLanding.direction = leftFrontLanding.direction = rightFrontLanding.direction = railDirection;
    leftBackLanding.isLeft = leftFrontLanding.isLeft = true;

    this.stairPostsPositions.push(
      leftBackLanding,
      rightBackLanding,
      leftFrontLanding,
      rightFrontLanding
    );
  }

  addHandrailAndBaserailForStairsLandingLeft(stairs): Feeney.IAddHandrailResult {
    const top = stairs.children.filter(function (item) {
      return item.name === 'Top';
    });
    const bottom = stairs.children.filter(function (item) {
      return item.name === 'Bottom';
    });
    const landing = stairs.children.filter(function (item) {
      return item.name === 'Landing';
    });
    const leftSideTop = stairs.children.filter(function (item) {
      return item.name === 'LeftTop';
    });
    const leftSideBottom = stairs.children.filter(function (item) {
      return item.name === 'LeftBottom';
    });

    let needLandingRail = true;
    let needRight = true;
    let countOfStepsRight = 0;
    let rightCorrection = null;

    const dist = top[0].position.clone().setY(0).distanceTo(bottom[0].position.clone().setY(0));
    const prev = new THREE.Vector3(
      stairs.userData.config.prevPoint.x,
      0,
      stairs.userData.config.prevPoint.y
    );
    const next = new THREE.Vector3(
      stairs.userData.config.nextPoint.x,
      0,
      stairs.userData.config.nextPoint.y
    );
    const first = new THREE.Vector3(
      stairs.userData.config.firstPoint.x,
      0,
      stairs.userData.config.firstPoint.y
    );
    const second = new THREE.Vector3(
      stairs.userData.config.secondPoint.x,
      0,
      stairs.userData.config.secondPoint.y
    );

    const prevEdgeLength = prev.distanceTo(first);
    const edgeLength = first.distanceTo(second);

    if (stairs.userData.config.prevPoint.superstructureType === 'wall') {
      if (
        stairs.userData.config.firstPoint.distance <
        stairs.userData.config.firstPoint.width / 2 + 1
      ) {
        if (
          stairs.userData.config.prevPoint.distance + stairs.userData.config.prevPoint.width / 2 >
          prevEdgeLength + dist + stairs.userData.config.width
        ) {
          needLandingRail = false;
          needRight = false;
        } else if (
          stairs.userData.config.prevPoint.distance + stairs.userData.config.prevPoint.width / 2 >
          prevEdgeLength + dist + 20
        ) {
          needRight = false;
        } else if (
          stairs.userData.config.prevPoint.distance + stairs.userData.config.prevPoint.width / 2 >
          prevEdgeLength + this.stairLength
        ) {
          countOfStepsRight = Math.round(
            (stairs.userData.config.prevPoint.distance +
              stairs.userData.config.prevPoint.width / 2 -
              prevEdgeLength) /
            this.stairLength
          );
          rightCorrection = bottom[0].position
            .clone()
            .setY(0)
            .sub(top[0].position.clone().setY(0))
            .setLength(this.stairLength * countOfStepsRight)
            .add(new THREE.Vector3(0, (-this.stairLength / 9) * 7 * countOfStepsRight));
        }
      }
    }

    const upVector = new THREE.Vector3(0, this.stepHieght, 0);

    let direction = new THREE.Vector3(
      bottom[0].position.x - top[0].position.x,
      0,
      bottom[0].position.z - top[0].position.z
    );

    let woodCorrection = direction.clone().negate().setLength(this.intermediatePost.userData.entity.width);
    const normal = direction.clone();
    normal.normalize();
    const nr = normal.clone();
    nr.setLength(11.52);
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    const leftTop = top[0].position.clone(),
      rightTop = top[0].position.clone(),
      leftBottom = bottom[0].position.clone(),
      rightBottom = bottom[0].position.clone(),
      leftFrontLanding = landing[0].position.clone(),
      rightFrontLanding = landing[0].position.clone(),
      leftBackLanding = landing[0].position.clone(),
      rightBackLanding = landing[0].position.clone(),
      leftSideLeftTop = leftSideTop[0].position.clone(),
      leftSideRightTop = leftSideTop[0].position.clone(),
      leftSideLeftBottom = leftSideBottom[0].position.clone(),
      leftSideRightBottom = leftSideBottom[0].position.clone();

    leftBackLanding.y += (17.78 + 2.54) / 2;
    rightBackLanding.y += (17.78 + 2.54) / 2;
    leftFrontLanding.y += (17.78 + 2.54) / 2;
    rightFrontLanding.y += (17.78 + 2.54) / 2;

    leftBottom.add(direction);
    leftTop.add(direction);
    leftBackLanding.add(direction);

    direction.setLength((stairs.userData.config.width - this.sizeHelper.INCHToCM(9) + 8.6328) / 2);
    leftFrontLanding.add(direction);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    direction.negate();
    rightBottom.add(direction);
    rightTop.add(direction);
    rightBackLanding.add(direction);
    rightFrontLanding.add(direction);

    direction = new THREE.Vector3(-direction.z, 0, direction.x);

    direction.negate();
    // direction.setLength(direction.length() - 9);
    leftBackLanding.add(direction);
    rightBackLanding.add(direction);
    direction.negate();
    // direction.setLength(direction.length() + 9);
    rightFrontLanding.add(direction);
    leftFrontLanding.add(direction);

    leftSideLeftBottom.y += (14.6 + 2.54) / 2 - (32.33 + 2.54) / 2;
    leftSideRightBottom.y += (14.6 + 2.54) / 2 - (32.33 + 2.54) / 2;

    direction = new THREE.Vector3(
      leftSideBottom[0].position.x - leftSideTop[0].position.x,
      0,
      leftSideBottom[0].position.z - leftSideTop[0].position.z
    );
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    leftSideLeftBottom.add(direction);
    leftSideLeftTop.add(direction);
    direction.negate();
    leftSideRightBottom.add(direction);
    leftSideRightTop.add(direction);

    const LeftBottom = leftBottom.clone();
    const RightBottom = rightBottom.clone();
    let dir = new THREE.Vector3(
      leftTop.x - leftBottom.x,
      leftTop.y - leftBottom.y,
      leftTop.z - leftBottom.z
    );
    dir.setLength(5);
    LeftBottom.add(dir);
    RightBottom.add(dir);

    if (this.intermediatePostOffset < 0) {
      leftBackLanding.add(upVector);
      // upVector.setLength(13);
      // upVector.negate();
      // leftBackLanding.add(upVector);
      const frontVector = new THREE.Vector3(
        rightFrontLanding.x - rightBackLanding.x,
        0,
        rightFrontLanding.z - rightBackLanding.z
      );
      frontVector.setLength(this.stepLength);
      rightBackLanding.add(frontVector);
    }

    const LeftSideLeftBottom = leftSideLeftBottom.clone();
    const LeftSideRightBottom = leftSideRightBottom.clone();
    dir = new THREE.Vector3(
      leftSideLeftTop.x - leftSideLeftBottom.x,
      leftSideLeftTop.y - leftSideLeftBottom.y,
      leftSideLeftTop.z - leftSideLeftBottom.z
    );
    dir.setLength(20);
    LeftSideLeftBottom.add(dir);
    LeftSideRightBottom.add(dir);

    leftBackLanding.vector = normal;
    rightBackLanding.vector = normal;
    leftFrontLanding.vector = normal;
    rightFrontLanding.vector = normal;
    leftSideLeftBottom.y += (32.33 + 2.54) / 2;
    leftSideRightBottom.y += (32.33 + 2.54) / 2;
    leftSideLeftBottom.vector = normal;
    leftSideRightBottom.vector = normal;

    direction.setLength(1);
    direction.negate();
    direction = new THREE.Vector3(direction.z, 0, -direction.x);

    leftBackLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    rightBackLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    direction = new THREE.Vector3(-direction.z, 0, direction.x);

    leftFrontLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    rightFrontLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    leftSideRightBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    leftSideLeftBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    const leftTopPostPosition = stairs.userData.config.firstPoint.secondPostPosition;
    const rightTopPostPosition = stairs.userData.config.firstPoint.firstPostPosition;
    if (stairs.needCorrection) {
      rightTopPostPosition.add(woodCorrection);
    }
    leftTopPostPosition.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    rightTopPostPosition.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    leftTopPostPosition.direction = rightTopPostPosition.direction = direction;

    leftTopPostPosition.isConnectedWithHorizontal = false;
    leftBackLanding.isConnectedWithHorizontal = false;
    rightTopPostPosition.isConnectedWithHorizontal = false;
    rightBackLanding.isConnectedWithHorizontal = true;
    leftFrontLanding.isConnectedWithHorizontal = true;
    rightFrontLanding.isConnectedWithHorizontal = true;
    leftSideLeftBottom.isConnectedWithHorizontal = false;
    leftSideRightBottom.isConnectedWithHorizontal = false;

    leftTopPostPosition.isConnectedWithNonHorizontal = true;
    leftBackLanding.isConnectedWithNonHorizontal = true;
    rightTopPostPosition.isConnectedWithNonHorizontal = true;
    rightBackLanding.isConnectedWithNonHorizontal = needRight;
    leftFrontLanding.isConnectedWithNonHorizontal = true;
    rightFrontLanding.isConnectedWithNonHorizontal = false;
    leftSideLeftBottom.isConnectedWithNonHorizontal = true;
    leftSideRightBottom.isConnectedWithNonHorizontal = true;

    leftTopPostPosition.needHalfAngle = true;
    leftBackLanding.needHalfAngle = true;
    rightTopPostPosition.needHalfAngle = true;
    rightBackLanding.needHalfAngle = true;
    leftFrontLanding.needHalfAngle = true;
    rightFrontLanding.needHalfAngle = true;
    leftSideLeftBottom.needHalfAngle = false;
    leftSideRightBottom.needHalfAngle = false;

    rightFrontLanding.corner = needLandingRail;
    rightFrontLanding.nextFloorPoint = rightBackLanding;
    rightFrontLanding.previousFloorPoint = leftFrontLanding;
    if (needLandingRail) {
      this.infillsForStairsAndLanding.addInfillForLanding(
        rightBackLanding,
        rightFrontLanding,
        this.infills,
        this.railingComponents
      );
    }
    this.infillsForStairsAndLanding.addInfillForLanding(
      rightFrontLanding,
      leftFrontLanding,
      this.infills,
      this.railingComponents
    );

    const frontVector = new THREE.Vector3(
      rightBackLanding.x - rightFrontLanding.x,
      0,
      rightBackLanding.z - rightFrontLanding.z
    );
    frontVector.setLength(1);

    const sideVector = new THREE.Vector3(
      leftFrontLanding.x - rightFrontLanding.x,
      0,
      leftFrontLanding.z - rightFrontLanding.z
    );
    sideVector.setLength(1);

    rightFrontLanding.vector = frontVector.add(sideVector);

    rightBackLanding.isLowerPoint = needRight;
    leftBackLanding.isLowerPoint = true;

    const firstLeftTopPoint = leftTopPostPosition.clone();
    const secondLeftTopPoint = leftTopPostPosition.clone();
    const firstRightTopPoint = rightTopPostPosition.clone();
    const secondRightTopPoint = rightTopPostPosition.clone();

    const leftToRight = new THREE.Vector3(
      rightTopPostPosition.x - leftTopPostPosition.x,
      0,
      rightTopPostPosition.z - leftTopPostPosition.z
    );
    const rightToLeft = new THREE.Vector3(
      leftTopPostPosition.x - rightTopPostPosition.x,
      0,
      leftTopPostPosition.z - rightTopPostPosition.z
    );
    leftToRight.setLength(this.handrailForFloor.userData.entity.width / 2);
    rightToLeft.setLength(this.handrailForFloor.userData.entity.width / 2);
    firstLeftTopPoint.add(rightToLeft);
    firstRightTopPoint.add(leftToRight);

    leftTopPostPosition.isTop = true;
    leftTopPostPosition.firstPost = firstLeftTopPoint;
    leftTopPostPosition.secondPost = secondLeftTopPoint;
    rightTopPostPosition.isTop = true;
    rightTopPostPosition.firstPost = firstRightTopPoint;
    rightTopPostPosition.secondPost = secondRightTopPoint;

    leftBackLanding.isInsideCorner = true;

    let straightRightSidePosts = [];

    let rails: Array<Feeney.Rail.IRail> = [];
    if (needRight) {
      if (countOfStepsRight) {
        rightTopPostPosition.add(rightCorrection);
        rightTopPostPosition.firstPost.add(rightCorrection);
        rightTopPostPosition.secondPost.add(rightCorrection);
        // rightTopPostPosition.isTop = false;
        straightRightSidePosts.push(rightTopPostPosition);
        this.stairPostsPositions.push(rightTopPostPosition);
      }
      straightRightSidePosts = this.setPositionForIntermediatePostsOnStairs(
        rightTopPostPosition,
        rightBackLanding,
        false
      );
      rails = rails.concat(
        this.addNonHorizontalHandrailAndBaserail(
          rightTopPostPosition,
          rightBackLanding,
          false,
          true
        )
      );
    }

    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(leftTopPostPosition, leftBackLanding, true, true)
    );
    const straightLeftSidePosts = this.setPositionForIntermediatePostsOnStairs(
      leftTopPostPosition,
      leftBackLanding,
      true
    );

    if (needLandingRail) {
      rails = rails.concat(
        this.infillsService.addHandrailAndBaserail(
          null,
          rightBackLanding,
          rightFrontLanding,
          this.railingComponent,
          null,
          null,
          rightFrontLanding,
          leftFrontLanding,
          true
        )
      );

      rails = rails.concat(
        this.infillsService.addHandrailAndBaserail(
          null,
          rightFrontLanding,
          leftFrontLanding,
          this.railingComponent,
          rightBackLanding,
          rightFrontLanding,
          null,
          null,
          true
        )
      );
    } else {
      rails = rails.concat(
        this.infillsService.addHandrailAndBaserail(
          null,
          rightFrontLanding,
          leftFrontLanding,
          this.railingComponent,
          null,
          null,
          null,
          null,
          true
        )
      );
    }

    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(leftBackLanding, leftSideLeftBottom, true, false)
    );
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(leftFrontLanding, leftSideRightBottom, false, false)
    );
    const leftLeftSidePosts = this.setPositionForIntermediatePostsOnStairs(
      leftBackLanding,
      leftSideLeftBottom,
      true
    );
    const leftRightSidePosts = this.setPositionForIntermediatePostsOnStairs(
      leftFrontLanding,
      leftSideRightBottom,
      false
    );

    leftBackLanding.isLeft = true;
    rightBackLanding.isLeft = false;
    leftFrontLanding.isFrontLanding = true;
    rightFrontLanding.isFrontLanding = true;
    leftSideRightBottom.isLeft = false;
    leftSideLeftBottom.isLeft = true;

    leftBackLanding.direction = new THREE.Vector3(
      leftSideBottom[0].position.x - leftSideTop[0].position.x,
      0,
      leftSideBottom[0].position.z - leftSideTop[0].position.z
    );
    rightBackLanding.direction = new THREE.Vector3(
      bottom[0].position.x - top[0].position.x,
      0,
      bottom[0].position.z - top[0].position.z
    );

    leftFrontLanding.direction = new THREE.Vector3(
      leftFrontLanding.x - rightFrontLanding.x,
      0,
      leftFrontLanding.z - rightFrontLanding.z
    );
    rightFrontLanding.isCorner = needLandingRail;

    const bottomDirection = new THREE.Vector3(
      leftSideRightBottom.x - leftFrontLanding.x,
      0,
      leftSideRightBottom.z - leftFrontLanding.z
    );
    leftSideRightBottom.isBottom = leftSideLeftBottom.isBottom = true;
    leftSideRightBottom.direction = leftSideLeftBottom.direction = bottomDirection;

    straightLeftSidePosts.push(leftBackLanding);
    straightRightSidePosts.push(rightBackLanding);
    leftLeftSidePosts.push(leftSideLeftBottom);
    leftRightSidePosts.push(leftSideRightBottom);

    if (!needLandingRail) {
      rightFrontLanding.direction = direction;
      rightFrontLanding.vector = direction;
    }
    this.stairPostsPositions.push(
      leftBackLanding,
      leftFrontLanding,
      rightFrontLanding,
      leftSideRightBottom,
      leftSideLeftBottom
    );
    if (needLandingRail) {
      this.stairPostsPositions.push(rightBackLanding);
    }

    leftSideRightBottom.isTerminationPost = leftSideLeftBottom.isTerminationPost = true;
    rightFrontLanding.corner = needLandingRail;
    rightFrontLanding.isTerminationPost = !needLandingRail;
    leftBackLanding.isTerminationPost = rightBackLanding.isTerminationPost = leftFrontLanding.isTerminationPost = true;

    return {
      rails,
      edgePosts: [
        {
          edge: new Edge(leftTopPostPosition, leftBackLanding),
          postData: straightLeftSidePosts
        },
        {
          edge: new Edge(rightTopPostPosition, rightBackLanding),
          postData: straightRightSidePosts
        },
        {
          edge: new Edge(rightBackLanding, rightFrontLanding),
          postData: [rightFrontLanding]
        },
        {
          edge: new Edge(leftFrontLanding, rightFrontLanding),
          postData: [leftFrontLanding]
        },
        {
          edge: new Edge(leftBackLanding, leftSideLeftBottom),
          postData: leftLeftSidePosts
        },
        {
          edge: new Edge(leftFrontLanding, leftSideRightBottom),
          postData: leftRightSidePosts
        }
      ]
    };
  }

  addHandrailAndBaserailForStairsLandingRight(stairs): Feeney.IAddHandrailResult {
    const top = stairs.children.filter(function (item) {
      return item.name === 'Top';
    });
    const bottom = stairs.children.filter(function (item) {
      return item.name === 'Bottom';
    });
    const landing = stairs.children.filter(function (item) {
      return item.name === 'Landing';
    });
    const leftSideTop = stairs.children.filter(function (item) {
      return item.name === 'RightTop';
    });
    const leftSideBottom = stairs.children.filter(function (item) {
      return item.name === 'RightBottom';
    });

    let needLandingRail = true;
    let needLeft = true;
    let countOfStepsLeft = 0;
    let leftCorrection = null;

    const dist = top[0].position.clone().setY(0).distanceTo(bottom[0].position.clone().setY(0));
    const prev = new THREE.Vector3(
      stairs.userData.config.prevPoint.x,
      0,
      stairs.userData.config.prevPoint.y
    );
    const next = new THREE.Vector3(
      stairs.userData.config.nextPoint.x,
      0,
      stairs.userData.config.nextPoint.y
    );
    const first = new THREE.Vector3(
      stairs.userData.config.firstPoint.x,
      0,
      stairs.userData.config.firstPoint.y
    );
    const second = new THREE.Vector3(
      stairs.userData.config.secondPoint.x,
      0,
      stairs.userData.config.secondPoint.y
    );

    const prevEdgeLength = prev.distanceTo(first);
    const edgeLength = first.distanceTo(second);

    if (stairs.userData.config.secondPoint.superstructureType === 'wall') {
      if (
        stairs.userData.config.firstPoint.distance + stairs.userData.config.firstPoint.width / 2 >
        edgeLength - 1
      ) {
        if (
          stairs.userData.config.secondPoint.distance -
          stairs.userData.config.secondPoint.width / 2 <
          -dist - stairs.userData.config.width
        ) {
          needLandingRail = false;
          needLeft = false;
        } else if (
          stairs.userData.config.secondPoint.distance -
          stairs.userData.config.secondPoint.width / 2 <
          -dist - 20
        ) {
          needLeft = false;
        } else if (
          stairs.userData.config.secondPoint.distance -
          stairs.userData.config.secondPoint.width / 2 <
          -this.stairLength
        ) {
          countOfStepsLeft = Math.round(
            Math.abs(
              stairs.userData.config.secondPoint.distance -
              stairs.userData.config.secondPoint.width / 2
            ) / this.stairLength
          );
          leftCorrection = bottom[0].position
            .clone()
            .setY(0)
            .sub(top[0].position.clone().setY(0))
            .setLength(this.stairLength * countOfStepsLeft)
            .add(new THREE.Vector3(0, (-this.stairLength / 9) * 7 * countOfStepsLeft));
        }
      }
    }

    const upVector = new THREE.Vector3(0, this.stepHieght, 0);

    let direction = new THREE.Vector3(
      bottom[0].position.x - top[0].position.x,
      0,
      bottom[0].position.z - top[0].position.z
    );
    let woodCorrection = direction.clone().negate().setLength(this.intermediatePost.userData.entity.width);
    const normal = direction.clone();
    normal.normalize();
    const nr = normal.clone();
    nr.setLength(11.52);
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    const leftTop = top[0].position.clone(),
      rightTop = top[0].position.clone(),
      leftBottom = bottom[0].position.clone(),
      rightBottom = bottom[0].position.clone(),
      leftFrontLanding = landing[0].position.clone(),
      rightFrontLanding = landing[0].position.clone(),
      leftBackLanding = landing[0].position.clone(),
      rightBackLanding = landing[0].position.clone(),
      rightSideLeftTop = leftSideTop[0].position.clone(),
      rightSideRightTop = leftSideTop[0].position.clone(),
      rightSideLeftBottom = leftSideBottom[0].position.clone(),
      rightSideRightBottom = leftSideBottom[0].position.clone();

    leftBackLanding.y += (17.78 + 2.54) / 2;
    rightBackLanding.y += (17.78 + 2.54) / 2;
    leftFrontLanding.y += (17.78 + 2.54) / 2;
    rightFrontLanding.y += (17.78 + 2.54) / 2;

    leftBottom.add(direction);
    leftTop.add(direction);
    leftBackLanding.add(direction);
    leftFrontLanding.add(direction);
    direction.negate();
    rightBottom.add(direction);
    rightTop.add(direction);
    rightBackLanding.add(direction);

    direction.setLength((stairs.userData.config.width - this.sizeHelper.INCHToCM(9) + 8.6328) / 2);
    rightFrontLanding.add(direction);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    direction = new THREE.Vector3(-direction.z, 0, direction.x);

    direction.negate();
    // direction.setLength(direction.length() - 9);
    leftBackLanding.add(direction);
    rightBackLanding.add(direction);
    direction.negate();
    // direction.setLength(direction.length() + 9);
    rightFrontLanding.add(direction);
    leftFrontLanding.add(direction);

    rightSideLeftBottom.y += (14.6 + 2.54) / 2 - (32.33 + 2.54) / 2;
    rightSideRightBottom.y += (14.6 + 2.54) / 2 - (32.33 + 2.54) / 2;

    direction = new THREE.Vector3(
      leftSideBottom[0].position.x - leftSideTop[0].position.x,
      0,
      leftSideBottom[0].position.z - leftSideTop[0].position.z
    );
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    rightSideLeftBottom.add(direction);
    rightSideLeftTop.add(direction);
    direction.negate();
    rightSideRightBottom.add(direction);
    rightSideRightTop.add(direction);

    const LeftBottom = leftBottom.clone();
    const RightBottom = rightBottom.clone();
    let dir = new THREE.Vector3(
      leftTop.x - leftBottom.x,
      leftTop.y - leftBottom.y,
      leftTop.z - leftBottom.z
    );
    dir.setLength(5);
    LeftBottom.add(dir);
    RightBottom.add(dir);

    if (this.intermediatePostOffset < 0) {
      rightBackLanding.add(upVector);
      const frontVector = new THREE.Vector3(
        leftFrontLanding.x - leftBackLanding.x,
        0,
        leftFrontLanding.z - leftBackLanding.z
      );
      frontVector.setLength(this.stepLength);
      leftBackLanding.add(frontVector);
    }

    const RightSideLeftBottom = rightSideLeftBottom.clone();
    const RightSideRightBottom = rightSideRightBottom.clone();
    dir = new THREE.Vector3(
      rightSideLeftTop.x - rightSideLeftBottom.x,
      rightSideLeftTop.y - rightSideLeftBottom.y,
      rightSideLeftTop.z - rightSideLeftBottom.z
    );
    dir.setLength(20);
    RightSideLeftBottom.add(dir);
    RightSideRightBottom.add(dir);

    leftBackLanding.vector = normal;
    rightBackLanding.vector = normal;
    leftFrontLanding.vector = normal;
    rightFrontLanding.vector = normal;
    rightSideLeftBottom.y += (32.33 + 2.54) / 2;
    rightSideRightBottom.y += (32.33 + 2.54) / 2;
    rightSideLeftBottom.vector = normal;
    rightSideRightBottom.vector = normal;

    direction.setLength(1);
    direction.negate();
    direction = new THREE.Vector3(-direction.z, 0, direction.x);

    leftBackLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    rightBackLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    direction = new THREE.Vector3(direction.z, 0, -direction.x);

    rightSideRightBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    rightFrontLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    leftFrontLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    rightSideLeftBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    const leftTopPostPosition = stairs.userData.config.firstPoint.secondPostPosition;
    const rightTopPostPosition = stairs.userData.config.firstPoint.firstPostPosition;

    if (stairs.needCorrection) {
      rightTopPostPosition.add(woodCorrection);
    }

    leftTopPostPosition.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    rightTopPostPosition.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    leftTopPostPosition.direction = rightTopPostPosition.direction = direction;

    leftTopPostPosition.isConnectedWithHorizontal = false;
    leftBackLanding.isConnectedWithHorizontal = true;
    rightTopPostPosition.isConnectedWithHorizontal = false;
    rightBackLanding.isConnectedWithHorizontal = false;
    leftFrontLanding.isConnectedWithHorizontal = true;
    rightFrontLanding.isConnectedWithHorizontal = true;
    rightSideLeftBottom.isConnectedWithHorizontal = false;
    rightSideRightBottom.isConnectedWithHorizontal = false;

    leftTopPostPosition.isConnectedWithNonHorizontal = true;
    leftBackLanding.isConnectedWithNonHorizontal = needLeft;
    rightTopPostPosition.isConnectedWithNonHorizontal = true;
    rightBackLanding.isConnectedWithNonHorizontal = false;
    leftFrontLanding.isConnectedWithNonHorizontal = false;
    rightFrontLanding.isConnectedWithNonHorizontal = true;
    rightSideLeftBottom.isConnectedWithNonHorizontal = true;
    rightSideRightBottom.isConnectedWithNonHorizontal = true;

    leftTopPostPosition.needHalfAngle = true;
    leftBackLanding.needHalfAngle = true;
    rightTopPostPosition.needHalfAngle = true;
    rightBackLanding.needHalfAngle = true;
    leftFrontLanding.needHalfAngle = true;
    rightFrontLanding.needHalfAngle = true;
    rightSideLeftBottom.needHalfAngle = false;
    rightSideRightBottom.needHalfAngle = false;

    leftFrontLanding.corner = needLandingRail;
    leftFrontLanding.nextFloorPoint = leftBackLanding;
    leftFrontLanding.previousFloorPoint = rightFrontLanding;

    if (needLandingRail) {
      this.infillsForStairsAndLanding.addInfillForLanding(
        leftBackLanding,
        leftFrontLanding,
        this.infills,
        this.railingComponents
      );
    }
    this.infillsForStairsAndLanding.addInfillForLanding(
      rightFrontLanding,
      leftFrontLanding,
      this.infills,
      this.railingComponents
    );

    const frontVector = new THREE.Vector3(
      leftBackLanding.x - leftFrontLanding.x,
      0,
      leftBackLanding.z - leftFrontLanding.z
    );
    frontVector.setLength(1);

    const sideVector = new THREE.Vector3(
      rightFrontLanding.x - leftFrontLanding.x,
      0,
      rightFrontLanding.z - leftFrontLanding.z
    );
    sideVector.setLength(1);

    leftFrontLanding.vector = frontVector.add(sideVector);

    leftBackLanding.isLowerPoint = needLeft;
    rightBackLanding.isLowerPoint = true;

    const firstLeftTopPoint = leftTopPostPosition.clone();
    const secondLeftTopPoint = leftTopPostPosition.clone();
    const firstRightTopPoint = rightTopPostPosition.clone();
    const secondRightTopPoint = rightTopPostPosition.clone();

    const leftToRight = new THREE.Vector3(
      rightTopPostPosition.x - leftTopPostPosition.x,
      0,
      rightTopPostPosition.z - leftTopPostPosition.z
    );
    const rightToLeft = new THREE.Vector3(
      leftTopPostPosition.x - rightTopPostPosition.x,
      0,
      leftTopPostPosition.z - rightTopPostPosition.z
    );
    leftToRight.setLength(this.handrailForFloor.userData.entity.width / 2);
    rightToLeft.setLength(this.handrailForFloor.userData.entity.width / 2);
    firstLeftTopPoint.add(rightToLeft);
    firstRightTopPoint.add(leftToRight);

    leftTopPostPosition.isTop = true;
    leftTopPostPosition.firstPost = firstLeftTopPoint;
    leftTopPostPosition.secondPost = secondLeftTopPoint;
    rightTopPostPosition.isTop = true;
    rightTopPostPosition.firstPost = firstRightTopPoint;
    rightTopPostPosition.secondPost = secondRightTopPoint;

    rightBackLanding.isInsideCorner = true;

    let straightLeftSidePosts = [];
    let rails: Array<Feeney.Rail.IRail> = [];
    if (needLeft) {
      if (countOfStepsLeft) {
        leftTopPostPosition.add(leftCorrection);
        leftTopPostPosition.firstPost.add(leftCorrection);
        leftTopPostPosition.secondPost.add(leftCorrection);
        // rightTopPostPosition.isTop = false;
        straightLeftSidePosts.push(leftTopPostPosition);
        this.stairPostsPositions.push(leftTopPostPosition);
      }
      rails = rails.concat(
        this.addNonHorizontalHandrailAndBaserail(leftTopPostPosition, leftBackLanding, true, true)
      );
      straightLeftSidePosts = this.setPositionForIntermediatePostsOnStairs(
        leftTopPostPosition,
        leftBackLanding,
        true
      );
    }
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(rightTopPostPosition, rightBackLanding, false, true)
    );
    const straightRightSidePosts = this.setPositionForIntermediatePostsOnStairs(
      rightTopPostPosition,
      rightBackLanding,
      false
    );

    if (needLandingRail) {
      rails = rails.concat(
        this.infillsService.addHandrailAndBaserail(
          null,
          leftBackLanding,
          leftFrontLanding,
          this.railingComponent,
          null,
          null,
          leftFrontLanding,
          rightFrontLanding,
          true
        )
      );
      rails = rails.concat(
        this.infillsService.addHandrailAndBaserail(
          null,
          rightFrontLanding,
          leftFrontLanding,
          this.railingComponent,
          null,
          null,
          leftFrontLanding,
          leftBackLanding,
          true
        )
      );
    } else {
      rails = rails.concat(
        this.infillsService.addHandrailAndBaserail(
          null,
          rightFrontLanding,
          leftFrontLanding,
          this.railingComponent,
          null,
          null,
          null,
          null,
          true
        )
      );
    }

    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(rightFrontLanding, rightSideLeftBottom, true, false)
    );
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(rightBackLanding, rightSideRightBottom, false, false)
    );
    const rightLeftSidePosts = this.setPositionForIntermediatePostsOnStairs(
      rightFrontLanding,
      rightSideLeftBottom,
      true
    );
    const rightRightSidePosts = this.setPositionForIntermediatePostsOnStairs(
      rightBackLanding,
      rightSideRightBottom,
      false
    );

    leftBackLanding.isLeft = true;
    rightBackLanding.isLeft = false;
    leftFrontLanding.isFrontLanding = true;
    rightFrontLanding.isFrontLanding = true;
    rightSideRightBottom.isLeft = false;
    rightSideLeftBottom.isLeft = true;

    const backDir = new THREE.Vector3(
      bottom[0].position.x - top[0].position.x,
      0,
      bottom[0].position.z - top[0].position.z
    );
    leftBackLanding.direction = rightBackLanding.direction = backDir;

    leftFrontLanding.isCorner = needLandingRail;
    rightFrontLanding.direction = new THREE.Vector3(
      leftFrontLanding.x - rightFrontLanding.x,
      0,
      leftFrontLanding.z - rightFrontLanding.z
    );

    const bottomDirection = new THREE.Vector3(
      rightSideLeftBottom.x - rightFrontLanding.x,
      0,
      rightSideLeftBottom.z - rightFrontLanding.z
    );
    rightSideRightBottom.isBottom = rightSideLeftBottom.isBottom = true;
    rightSideRightBottom.direction = rightSideLeftBottom.direction = bottomDirection;

    if (!needLandingRail) {
      leftFrontLanding.direction = direction;
      leftFrontLanding.vector = direction;
    }
    this.stairPostsPositions.push(
      rightBackLanding,
      leftFrontLanding,
      rightFrontLanding,
      rightSideRightBottom,
      rightSideLeftBottom
    );
    if (needLandingRail) {
      this.stairPostsPositions.push(leftBackLanding);
    }

    rightSideRightBottom.isTerminationPost = rightSideLeftBottom.isTerminationPost = true;
    leftFrontLanding.corner = needLandingRail;
    leftFrontLanding.isTerminationPost = !needLandingRail;
    leftBackLanding.isTerminationPost = rightBackLanding.isTerminationPost = rightFrontLanding.isTerminationPost = true;

    straightLeftSidePosts.push(leftBackLanding);
    straightRightSidePosts.push(rightBackLanding);

    rightLeftSidePosts.push(rightSideLeftBottom);
    rightRightSidePosts.push(rightSideRightBottom);

    return {
      rails,
      edgePosts: [
        {
          edge: new Edge(leftTopPostPosition, leftBackLanding),
          postData: straightLeftSidePosts
        },
        {
          edge: new Edge(rightTopPostPosition, rightBackLanding),
          postData: straightRightSidePosts
        },
        {
          edge: new Edge(leftBackLanding, leftFrontLanding),
          postData: [leftFrontLanding]
        },
        {
          edge: new Edge(leftFrontLanding, rightFrontLanding),
          postData: [rightFrontLanding]
        },
        {
          edge: new Edge(rightFrontLanding, rightSideLeftBottom),
          postData: rightLeftSidePosts
        },
        {
          edge: new Edge(rightBackLanding, rightSideRightBottom),
          postData: rightRightSidePosts
        }
      ]
    };
  }

  addHandrailAndBaserailForStairsLandingBothSides(stairs): Feeney.IAddHandrailResult {
    const top = stairs.children.filter(function (item) {
      return item.name === 'Top';
    });
    const bottom = stairs.children.filter(function (item) {
      return item.name === 'Bottom';
    });
    const landing = stairs.children.filter(function (item) {
      return item.name === 'Landing';
    });
    const rightSideTop = stairs.children.filter(function (item) {
      return item.name === 'RightTop';
    });
    const rightSideBottom = stairs.children.filter(function (item) {
      return item.name === 'RightBottom';
    });
    const leftSideTop = stairs.children.filter(function (item) {
      return item.name === 'LeftTop';
    });
    const leftSideBottom = stairs.children.filter(function (item) {
      return item.name === 'LeftBottom';
    });

    const upVector = new THREE.Vector3(0, this.stepHieght, 0);

    let direction = new THREE.Vector3(
      bottom[0].position.x - top[0].position.x,
      0,
      bottom[0].position.z - top[0].position.z
    );
    let woodCorrection = direction.clone().negate().setLength(this.intermediatePost.userData.entity.width);
    const normal = direction.clone();
    normal.normalize();
    const nr = normal.clone();
    nr.setLength(11.52);
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    const leftTop = top[0].position.clone(),
      rightTop = top[0].position.clone(),
      leftBottom = bottom[0].position.clone(),
      rightBottom = bottom[0].position.clone(),
      leftFrontLanding = landing[0].position.clone(),
      rightFrontLanding = landing[0].position.clone(),
      leftBackLanding = landing[0].position.clone(),
      rightBackLanding = landing[0].position.clone(),
      leftSideLeftTop = leftSideTop[0].position.clone(),
      leftSideRightTop = leftSideTop[0].position.clone(),
      leftSideLeftBottom = leftSideBottom[0].position.clone(),
      leftSideRightBottom = leftSideBottom[0].position.clone(),
      rightSideLeftTop = rightSideTop[0].position.clone(),
      rightSideRightTop = rightSideTop[0].position.clone(),
      rightSideLeftBottom = rightSideBottom[0].position.clone(),
      rightSideRightBottom = rightSideBottom[0].position.clone();

    leftBackLanding.y += (17.78 + 2.54) / 2;
    rightBackLanding.y += (17.78 + 2.54) / 2;
    leftFrontLanding.y += (17.78 + 2.54) / 2;
    rightFrontLanding.y += (17.78 + 2.54) / 2;

    leftBottom.add(direction);
    leftTop.add(direction);
    leftBackLanding.add(direction);

    direction.setLength((stairs.userData.config.width - this.sizeHelper.INCHToCM(9) + 8.6328) / 2);
    leftFrontLanding.add(direction);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    direction.negate();
    rightBottom.add(direction);
    rightTop.add(direction);
    rightBackLanding.add(direction);

    direction.setLength((stairs.userData.config.width - this.sizeHelper.INCHToCM(9) + 8.6328) / 2);
    rightFrontLanding.add(direction);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    direction = new THREE.Vector3(-direction.z, 0, direction.x);

    direction.negate();
    // direction.setLength(direction.length() - 9);
    leftBackLanding.add(direction);
    rightBackLanding.add(direction);
    direction.negate();
    // direction.setLength(direction.length() + 9);
    rightFrontLanding.add(direction);
    leftFrontLanding.add(direction);

    rightSideLeftBottom.y += (14.6 + 2.54) / 2 - (32.33 + 2.54) / 2;
    rightSideRightBottom.y += (14.6 + 2.54) / 2 - (32.33 + 2.54) / 2;
    leftSideLeftBottom.y += (14.6 + 2.54) / 2 - (32.33 + 2.54) / 2;
    leftSideRightBottom.y += (14.6 + 2.54) / 2 - (32.33 + 2.54) / 2;

    direction = new THREE.Vector3(
      rightSideBottom[0].position.x - rightSideTop[0].position.x,
      0,
      rightSideBottom[0].position.z - rightSideTop[0].position.z
    );
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    rightSideLeftBottom.add(direction);
    rightSideLeftTop.add(direction);
    direction.negate();
    rightSideRightBottom.add(direction);
    rightSideRightTop.add(direction);

    direction = new THREE.Vector3(
      leftSideBottom[0].position.x - leftSideTop[0].position.x,
      0,
      leftSideBottom[0].position.z - leftSideTop[0].position.z
    );
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(
      stairs.userData.config.width / 2 - this.sizeHelper.INCHToCM(2.5) - this.intermediatePostOffset
    );

    leftSideLeftBottom.add(direction);
    leftSideLeftTop.add(direction);
    direction.negate();
    leftSideRightBottom.add(direction);
    leftSideRightTop.add(direction);

    const LeftBottom = leftBottom.clone();
    const RightBottom = rightBottom.clone();
    let dir = new THREE.Vector3(
      leftTop.x - leftBottom.x,
      leftTop.y - leftBottom.y,
      leftTop.z - leftBottom.z
    );
    dir.setLength(5);
    LeftBottom.add(dir);
    RightBottom.add(dir);

    if (this.intermediatePostOffset < 0) {
      rightBackLanding.add(upVector);
      leftBackLanding.add(upVector);
    }

    this.infillsForStairsAndLanding.addInfillForLanding(
      rightFrontLanding,
      leftFrontLanding,
      this.infills,
      this.railingComponents
    );

    const LeftSideLeftBottom = leftSideLeftBottom.clone();
    const LeftSideRightBottom = leftSideRightBottom.clone();
    dir = new THREE.Vector3(
      leftSideLeftTop.x - leftSideLeftBottom.x,
      leftSideLeftTop.y - leftSideLeftBottom.y,
      leftSideLeftTop.z - leftSideLeftBottom.z
    );
    dir.setLength(20);
    LeftSideLeftBottom.add(dir);
    LeftSideRightBottom.add(dir);

    const RightSideLeftBottom = rightSideLeftBottom.clone();
    const RightSideRightBottom = rightSideRightBottom.clone();
    dir = new THREE.Vector3(
      rightSideLeftTop.x - rightSideLeftBottom.x,
      rightSideLeftTop.y - rightSideLeftBottom.y,
      rightSideLeftTop.z - rightSideLeftBottom.z
    );
    dir.setLength(20);
    RightSideLeftBottom.add(dir);
    RightSideRightBottom.add(dir);

    leftBackLanding.vector = normal;
    rightBackLanding.vector = normal;
    leftFrontLanding.vector = normal;
    rightFrontLanding.vector = normal;
    rightSideLeftBottom.y += (32.33 + 2.54) / 2;
    rightSideRightBottom.y += (32.33 + 2.54) / 2;
    rightSideLeftBottom.vector = normal;
    rightSideRightBottom.vector = normal;
    leftSideLeftBottom.y += (32.33 + 2.54) / 2;
    leftSideRightBottom.y += (32.33 + 2.54) / 2;
    leftSideLeftBottom.vector = normal;
    leftSideRightBottom.vector = normal;

    direction.setLength(1);
    direction.negate();
    direction = new THREE.Vector3(-direction.z, 0, direction.x);

    rightBackLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    direction.negate();
    leftBackLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    direction = new THREE.Vector3(-direction.z, 0, direction.x);

    rightSideRightBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    leftSideLeftBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    direction.negate();

    rightFrontLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    leftFrontLanding.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    rightSideLeftBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);
    leftSideRightBottom.vector = new THREE.Vector3(direction.x, direction.y, direction.z);

    const leftTopPostPosition = stairs.userData.config.firstPoint.secondPostPosition;
    const rightTopPostPosition = stairs.userData.config.firstPoint.firstPostPosition;

    if (stairs.needCorrection) {
      rightTopPostPosition.add(woodCorrection);
    }

    leftTopPostPosition.isConnectedWithHorizontal = false;
    leftBackLanding.isConnectedWithHorizontal = false;
    rightTopPostPosition.isConnectedWithHorizontal = false;
    rightBackLanding.isConnectedWithHorizontal = false;
    leftFrontLanding.isConnectedWithHorizontal = true;
    rightFrontLanding.isConnectedWithHorizontal = true;
    rightSideLeftBottom.isConnectedWithHorizontal = false;
    rightSideRightBottom.isConnectedWithHorizontal = false;

    leftTopPostPosition.isConnectedWithNonHorizontal = true;
    leftBackLanding.isConnectedWithNonHorizontal = false;
    rightTopPostPosition.isConnectedWithNonHorizontal = true;
    rightBackLanding.isConnectedWithNonHorizontal = false;
    leftFrontLanding.isConnectedWithNonHorizontal = true;
    rightFrontLanding.isConnectedWithNonHorizontal = true;
    rightSideLeftBottom.isConnectedWithNonHorizontal = true;
    rightSideRightBottom.isConnectedWithNonHorizontal = true;

    leftTopPostPosition.needHalfAngle = true;
    leftBackLanding.needHalfAngle = true;
    rightTopPostPosition.needHalfAngle = true;
    rightBackLanding.needHalfAngle = true;
    leftFrontLanding.needHalfAngle = true;
    rightFrontLanding.needHalfAngle = true;
    rightSideLeftBottom.needHalfAngle = false;
    rightSideRightBottom.needHalfAngle = false;
    leftSideLeftBottom.needHalfAngle = false;
    leftSideRightBottom.needHalfAngle = false;

    const firstLeftTopPoint = leftTopPostPosition.clone();
    const secondLeftTopPoint = leftTopPostPosition.clone();
    const firstRightTopPoint = rightTopPostPosition.clone();
    const secondRightTopPoint = rightTopPostPosition.clone();

    const leftToRight = new THREE.Vector3(
      rightTopPostPosition.x - leftTopPostPosition.x,
      0,
      rightTopPostPosition.z - leftTopPostPosition.z
    );
    const rightToLeft = new THREE.Vector3(
      leftTopPostPosition.x - rightTopPostPosition.x,
      0,
      leftTopPostPosition.z - rightTopPostPosition.z
    );
    leftToRight.setLength(this.handrailForFloor.userData.entity.width / 2);
    rightToLeft.setLength(this.handrailForFloor.userData.entity.width / 2);
    firstLeftTopPoint.add(rightToLeft);
    firstRightTopPoint.add(leftToRight);

    leftTopPostPosition.isTop = true;
    leftTopPostPosition.firstPost = firstLeftTopPoint;
    leftTopPostPosition.secondPost = secondLeftTopPoint;
    rightTopPostPosition.isTop = true;
    rightTopPostPosition.firstPost = firstRightTopPoint;
    rightTopPostPosition.secondPost = secondRightTopPoint;

    leftBackLanding.isInsideCorner = true;
    rightBackLanding.isInsideCorner = true;

    let rails: Array<Feeney.Rail.IRail> = [];
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(leftTopPostPosition, leftBackLanding, true, true)
    );
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(rightTopPostPosition, rightBackLanding, false, true)
    );
    const straightLeftSidePosts = this.setPositionForIntermediatePostsOnStairs(
      leftTopPostPosition,
      leftBackLanding,
      true
    );
    const straightRightSidePosts = this.setPositionForIntermediatePostsOnStairs(
      rightTopPostPosition,
      rightBackLanding,
      false
    );
    rails = rails.concat(
      this.infillsService.addHandrailAndBaserail(
        null,
        rightFrontLanding,
        leftFrontLanding,
        this.railingComponent,
        null,
        null,
        null,
        null,
        true
      )
    );
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(rightFrontLanding, rightSideLeftBottom, true, false)
    );
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(rightBackLanding, rightSideRightBottom, false, false)
    );
    const rightLeftSidePosts = this.setPositionForIntermediatePostsOnStairs(
      rightFrontLanding,
      rightSideLeftBottom,
      true
    );
    const rightRightSidePosts = this.setPositionForIntermediatePostsOnStairs(
      rightBackLanding,
      rightSideRightBottom,
      false
    );
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(leftBackLanding, leftSideLeftBottom, true, false)
    );
    rails = rails.concat(
      this.addNonHorizontalHandrailAndBaserail(leftFrontLanding, leftSideRightBottom, false, false)
    );
    const leftLeftSidePosts = this.setPositionForIntermediatePostsOnStairs(
      leftBackLanding,
      leftSideLeftBottom,
      true
    );
    const leftRightSidePosts = this.setPositionForIntermediatePostsOnStairs(
      leftFrontLanding,
      leftSideRightBottom,
      false
    );

    leftBackLanding.isLeft = true;
    rightBackLanding.isLeft = false;
    leftFrontLanding.isFrontLanding = true;
    rightFrontLanding.isFrontLanding = true;
    rightSideRightBottom.isLeft = false;
    rightSideLeftBottom.isLeft = true;
    leftSideLeftBottom.isLeft = true;
    leftSideRightBottom.isLeft = false;
    rightFrontLanding.isLeft = true;

    const backdirection = new THREE.Vector3(
      bottom[0].position.x - top[0].position.x,
      0,
      bottom[0].position.z - top[0].position.z
    );
    leftBackLanding.direction = rightBackLanding.direction = backdirection;

    const leftDirection = new THREE.Vector3(
      leftSideRightBottom.x - leftFrontLanding.x,
      0,
      leftSideRightBottom.z - leftFrontLanding.z
    );
    leftSideLeftBottom.direction = leftSideRightBottom.direction = leftFrontLanding.direction = leftDirection;

    const rightDirection = new THREE.Vector3(
      rightSideLeftBottom.x - rightFrontLanding.x,
      0,
      rightSideLeftBottom.z - rightFrontLanding.z
    );
    rightSideLeftBottom.direction = rightSideRightBottom.direction = rightFrontLanding.direction = rightDirection;

    rightSideRightBottom.isBottom = rightSideLeftBottom.isBottom = leftSideLeftBottom.isBottom = leftSideRightBottom.isBottom = true;

    this.stairPostsPositions.push(
      leftBackLanding,
      rightBackLanding,
      leftFrontLanding,
      rightFrontLanding,
      rightSideRightBottom,
      rightSideLeftBottom,
      leftSideLeftBottom,
      leftSideRightBottom
    );

    leftBackLanding.isTerminationPost = rightBackLanding.isTerminationPost = leftFrontLanding.isTerminationPost = rightFrontLanding.isTerminationPost = rightSideRightBottom.isTerminationPost = rightSideLeftBottom.isTerminationPost = leftSideLeftBottom.isTerminationPost = leftSideRightBottom.isTerminationPost = true;

    straightLeftSidePosts.push(leftBackLanding);
    straightRightSidePosts.push(rightBackLanding);
    leftLeftSidePosts.push(leftSideLeftBottom);
    leftRightSidePosts.push(leftSideRightBottom, leftFrontLanding);
    rightLeftSidePosts.push(rightSideLeftBottom, rightFrontLanding);
    rightRightSidePosts.push(rightSideRightBottom);

    return {
      rails,
      edgePosts: [
        {
          edge: new Edge(leftTopPostPosition, leftBackLanding),
          postData: straightLeftSidePosts
        },
        {
          edge: new Edge(rightTopPostPosition, rightBackLanding),
          postData: straightRightSidePosts
        },
        {
          edge: new Edge(leftFrontLanding, rightFrontLanding),
          postData: []
        },
        {
          edge: new Edge(rightFrontLanding, rightSideLeftBottom),
          postData: rightLeftSidePosts
        },
        {
          edge: new Edge(rightBackLanding, rightSideRightBottom),
          postData: rightRightSidePosts
        },
        {
          edge: new Edge(leftBackLanding, leftSideLeftBottom),
          postData: leftLeftSidePosts
        },
        {
          edge: new Edge(leftFrontLanding, leftSideRightBottom),
          postData: leftRightSidePosts
        }
      ]
    };
  }

  cloneObject3DMaterialAndGeometry(obj, material) {
    const newMesh = obj.clone();

    for (let i = 0; i < newMesh.children.length; i++) {
      if (newMesh.children[i]) {
        newMesh.children[i].geometry = obj.children[i].geometry.clone();
        newMesh.children[i].material = material;
      }
    }

    return newMesh;
  }

  addAngleToHandrail(obj, rightAngle, leftAngle) {
    const position = obj.geometry.attributes.position;
    const vertices = [];

    for (let i = 0, l = position.count; i < l; i++) {
      const vertice = new THREE.Vector3();
      vertice.fromBufferAttribute(position, i);
      vertice.applyMatrix4(obj.matrixWorld);
      vertices.push(vertice.clone());
    }

    for (let i = 0; i < vertices.length; i++) {
      // angle might be null (undefined),
      // in that case do not apply morph
      if (rightAngle && rightAngle > 0) {
        if (vertices[i].x > 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x > 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      } else {
        if (vertices[i].x > 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
        if (vertices[i].x > 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }

      if (leftAngle && leftAngle > 0) {
        if (vertices[i].x < 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x < 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      } else {
        if (vertices[i].x < 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x < 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }
    }

    const morphArr = [];

    vertices.forEach(v => {
      morphArr.push(v.x, v.y, v.z);
    });

    obj.geometry.morphAttributes.position = [];
    obj.geometry.morphAttributes.position[0] = new THREE.Float32BufferAttribute(
      new Float32Array(morphArr),
      3
    );
    obj.material.morphTargets = true;
    obj.updateMorphTargets();
    obj.morphTargetInfluences[0] = 1;
  }

  addNonHorizontalHandrailAndBaserail(
    FirstPoint,
    secondPoint,
    isLeft,
    isTopStairPart?
  ): Array<Feeney.Rail.IRail> {
    let postWidth;
    const result: Array<Feeney.Rail.IRail> = [];

    switch (this.currentParams.railingType) {
      case 'DesignRail': {
        postWidth = 6.035;
        break;
      }
      case 'Steel flat bar': {
        postWidth = 5.0028;
        break;
      }
      case 'Steel round tubular': {
        postWidth = 5.0028;
        break;
      }
      case 'Wood': {
        postWidth = this.intermediatePost.userData.entity.width - 0.25;
        break;
      }
      default: {
        // postWidth is the post's actual column; width is the base-plate
        // footprint, which is far wider on base-mounted posts
        postWidth =
          +this.intermediatePost.userData.entity.postWidth ||
          this.intermediatePost.userData.entity.width;
      }
    }

    const start = FirstPoint.clone();
    const end = secondPoint.clone();
    let firstPoint = FirstPoint.clone();
    firstPoint.y = secondPoint.y;
    let SecondPoint = secondPoint.clone();
    let horizontalDistance = firstPoint.distanceTo(secondPoint);
    firstPoint.y += (horizontalDistance * 7) / 9;

    let sub = secondPoint.clone().sub(firstPoint).setLength(5);
    // if (firstPoint.y < FirstPoint) {

    // }

    if (!secondPoint.needHalfAngle || secondPoint.isInsideCorner) {
      SecondPoint.add(sub);
    }

    let needHalfAngle = true;
    if (FirstPoint.isTop && !FirstPoint.isOutPoint) {
      if (FirstPoint.y > firstPoint.y) {
        needHalfAngle = false;

        const rails = this.infillsService.addHandrailAndBaserail(
          null,
          FirstPoint.firstPost,
          FirstPoint.secondPost,
          this.railingComponent,
          null,
          null,
          null,
          null
        );
        rails.forEach(r => (r.rail.userData.excludeFromLightMap = true));
      } else {
        const difference = ((firstPoint.y - FirstPoint.y) * 9) / 7;
        const Offset = new THREE.Vector3(
          SecondPoint.x - firstPoint.x,
          0,
          SecondPoint.z - firstPoint.z
        );
        Offset.setLength(difference);
        firstPoint.y = FirstPoint.y;
        firstPoint.add(Offset);

        let rails = this.infillsService.addHandrailAndBaserail(
          null,
          FirstPoint.firstPost,
          FirstPoint.secondPost,
          this.railingComponent,
          null,
          null,
          FirstPoint.secondPost,
          firstPoint
        );

        rails.forEach(r => (r.rail.userData.excludeFromLightMap = true));

        firstPoint.isConnectedWithNonHorizontal = true;

        rails = this.infillsService.addHandrailAndBaserail(
          null,
          FirstPoint.secondPost,
          firstPoint,
          this.railingComponent,
          FirstPoint.firstPost,
          FirstPoint.secondPost,
          null,
          null
        );

        rails.forEach(r => (r.rail.userData.excludeFromLightMap = true));
      }
    }

    if (FirstPoint.isTop && FirstPoint.isOutPoint) {
      if (FirstPoint.connectedWithAnotherStair) {
        if (FirstPoint.y > firstPoint.y) {
          needHalfAngle = false;

          FirstPoint.firstPost = FirstPoint.clone();
          const secondToFirst = new THREE.Vector3(
            firstPoint.x - SecondPoint.x,
            0,
            firstPoint.z - SecondPoint.z
          );
          secondToFirst.setLength(this.handrail.userData.entity.width / 2);

          FirstPoint.firstPost.add(secondToFirst);
          FirstPoint.firstPost.dontCut = true;

          const rails = this.infillsService.addHandrailAndBaserail(
            null,
            FirstPoint.firstPost,
            FirstPoint.secondPost,
            this.railingComponent,
            null,
            null,
            null,
            null
          );

          rails.forEach(r => (r.rail.userData.excludeFromLightMap = true));
        } else {
          needHalfAngle = true;

          const secondToFirst = new THREE.Vector3(
            firstPoint.x - SecondPoint.x,
            0,
            firstPoint.z - SecondPoint.z
          );
          // FirstPoint.firstPost = FirstPoint.clone();
          secondToFirst.setLength(this.handrail.userData.entity.width / 2);

          FirstPoint.firstPost.add(secondToFirst);
          FirstPoint.secondPost.add(secondToFirst);
          FirstPoint.secondPost.dontCut = true;

          // FirstPoint.secondPost.isConnectedWithNonHorizontal = true;

          let difference = ((firstPoint.y - FirstPoint.y) * 9) / 7;
          const Offset = new THREE.Vector3(
            SecondPoint.x - firstPoint.x,
            0,
            SecondPoint.z - firstPoint.z
          );
          Offset.setLength(difference);
          firstPoint.y = FirstPoint.y;
          firstPoint.add(Offset);

          firstPoint.isConnectedWithNonHorizontal = true;

          const rails = this.infillsService.addHandrailAndBaserail(
            null,
            FirstPoint.secondPost,
            firstPoint,
            this.railingComponent,
            FirstPoint.secondPost,
            FirstPoint.firstPost,
            null,
            null
          );

          rails.forEach(r => (r.rail.userData.excludeFromLightMap = true));

          difference = 0.55;
          Offset.setLength(difference);
          firstPoint.add(Offset);
        }
      } else {
        if (FirstPoint.y > firstPoint.y) {
          needHalfAngle = false;

          FirstPoint.firstPost = FirstPoint.clone();
          const secondToFirst = new THREE.Vector3(
            firstPoint.x - SecondPoint.x,
            0,
            firstPoint.z - SecondPoint.z
          );
          secondToFirst.setLength(postWidth);

          FirstPoint.firstPost.add(secondToFirst);

          const rails = this.infillsService.addHandrailAndBaserail(
            null,
            FirstPoint.firstPost,
            FirstPoint.secondPost,
            this.railingComponent,
            null,
            null,
            null,
            null
          );

          rails.forEach(r => (r.rail.userData.excludeFromLightMap = true));
        } else {
          needHalfAngle = true;

          FirstPoint.firstPost = FirstPoint.clone();
          const secondToFirst = new THREE.Vector3(
            firstPoint.x - SecondPoint.x,
            0,
            firstPoint.z - SecondPoint.z
          );
          secondToFirst.setLength(postWidth);

          FirstPoint.firstPost.add(secondToFirst);

          FirstPoint.secondPost.isConnectedWithNonHorizontal = true;

          const difference = ((firstPoint.y - FirstPoint.y) * 9) / 7;
          const Offset = new THREE.Vector3(
            SecondPoint.x - firstPoint.x,
            0,
            SecondPoint.z - firstPoint.z
          );
          Offset.setLength(difference);
          firstPoint.y = FirstPoint.y;
          firstPoint.add(Offset);

          firstPoint.isConnectedWithNonHorizontal = true;

          const rails = this.infillsService.addHandrailAndBaserail(
            null,
            FirstPoint.firstPost,
            firstPoint,
            this.railingComponent,
            null,
            null,
            null,
            null
          );

          rails.forEach(r => (r.rail.userData.excludeFromLightMap = true));
        }
      }
    }

    if (FirstPoint.isInsideCorner && this.intermediatePostOffset > 0) {
      const difference = ((firstPoint.y - FirstPoint.y + 2) * 9) / 7;
      const Offset = new THREE.Vector3(
        SecondPoint.x - firstPoint.x,
        0,
        SecondPoint.z - firstPoint.z
      );
      Offset.setLength(difference);
      firstPoint.y = FirstPoint.y - 2;
      firstPoint.add(Offset);

      const pointClone = FirstPoint.clone();
      pointClone.y = FirstPoint.y - 2;

      firstPoint.isConnectedWithNonHorizontal = true;

      Offset.setLength(postWidth / 2);
      pointClone.add(Offset);
      pointClone.dontCut = true;
      firstPoint.add(Offset);
      firstPoint.dontCut = true;

      const rails = this.infillsService.addHandrailAndBaserail(
        null,
        pointClone,
        firstPoint,
        this.railingComponent,
        null,
        null,
        null,
        null,
        true
      );

      rails.forEach(r => (r.rail.userData.excludeFromLightMap = true));

      firstPoint.add(Offset.negate());
    }

    const handrail = this.cloneObject3DMaterialAndGeometry(this.handrail, this.handrailMaterial);
    handrail.name = 'HandrailContainer';

    let correctionPositionHorizontal = new THREE.Vector3(
      SecondPoint.x - firstPoint.x,
      0,
      SecondPoint.z - firstPoint.z
    );
    const stairHandrailOffsetVector = new THREE.Vector3(
      -correctionPositionHorizontal.z,
      0,
      correctionPositionHorizontal.x
    );
    let stairHandrailOffset = 6.35 + this.intermediatePost.userData.entity.width / 2;
    let stairHandrailTopOffset = 4.12 + this.intermediatePost.userData.entity.width / 2;
    if (this.currentParams.postMounting === 'Fascia Bracket Mount') {
      stairHandrailOffset = 6.35 + this.intermediatePost.userData.entity.width / 2 - 3.5;
      stairHandrailTopOffset = 4.12 + this.intermediatePost.userData.entity.width / 2 - 3.5;
    }
    if (this.currentParams.postMounting === 'Base Mount') {
      stairHandrailOffset = 6.35 + this.intermediatePost.userData.entity.length / 2 - 3.3;
      stairHandrailTopOffset = 4.12 + this.intermediatePost.userData.entity.length / 2 - 3.3;

      if (this.currentParams.railingType === 'Steel round tubular') {
        stairHandrailOffset -= 1;
        stairHandrailTopOffset -= 1;
      }
    }
    if (
      this.currentParams.postMounting === 'Fascia Mount' &&
      this.currentParams.railingType === 'Steel flat bar'
    ) {
      stairHandrailOffset = 6.35 + this.intermediatePost.userData.entity.length / 2 - 1;
      stairHandrailTopOffset = 4.12 + this.intermediatePost.userData.entity.length / 2 - 1;
    }
    stairHandrailOffsetVector.setLength(stairHandrailOffset);
    if (this.intermediatePostOffset < 0 || this.currentParams.railingType === 'Wood') {
      correctionPositionHorizontal.setLength(postWidth / 2);
    } else {
      correctionPositionHorizontal.setLength(handrail.userData.entity.width / 2);
    }

    handrail.userData = { start, end, isLeft, nonHorizontal: true, ...handrail.userData };

    result.push({
      startPoint: FirstPoint.clone(),
      endPoint: SecondPoint.clone(),
      rail: handrail,
      verticalPosition: 'Top',
      isHorizontal: false
    });

    handrail.position.set(
      firstPoint.x / 2 + SecondPoint.x / 2,
      firstPoint.y / 2 +
      SecondPoint.y / 2 +
      handrail.userData.entity.placementHeight +
      handrail.userData.entity.height / 2,
      firstPoint.z / 2 + SecondPoint.z / 2
    );

    // if (this.intermediatePostOffset > 0 && this.currentParams.railingType === "Wood") {
    //   handrail.position.y -= 2;
    // }
    let direction = new THREE.Vector3(
      SecondPoint.x - firstPoint.x,
      0,
      SecondPoint.z - firstPoint.z
    );
    direction = new THREE.Vector3(-direction.z, 0, direction.x);
    direction.setLength(1);

    let horizonalDistance = Math.pow(
      Math.pow(firstPoint.x - SecondPoint.x, 2) + Math.pow(firstPoint.z - SecondPoint.z, 2),
      1 / 2
    );

    let scaleX = firstPoint.distanceTo(SecondPoint) / handrail.userData.entity.length;

    const morphAngle = Math.atan((firstPoint.y - SecondPoint.y) / horizonalDistance);
    let firstPointMorphAngle = morphAngle;
    let secondPointMorphAngle = -morphAngle;
    if (
      FirstPoint.needHalfAngle &&
      !(!FirstPoint.isConnectedWithHorizontal && this.intermediatePostOffset < 0) &&
      needHalfAngle
    ) {
      firstPointMorphAngle /= 2;
    }
    if (secondPoint.needHalfAngle && !secondPoint.isInsideCorner) {
      secondPointMorphAngle /= 2;
    }
    if (!secondPoint.needHalfAngle || secondPoint.isInsideCorner) {
      secondPointMorphAngle = 0;
    }

    handrail.children.forEach(c => {
      if (c) {
        c.matrix.makeScale(scaleX, 1, 1);
        c.geometry.applyMatrix(c.matrix);
        this.addAngleToHandrail(c, secondPointMorphAngle, firstPointMorphAngle);
      }
    });

    for (let i = 0; i < 3; i++) {
      const worldDir = handrail.getWorldDirection(new THREE.Vector3());
      if (
        !(
          direction.x - worldDir.x > -0.05 &&
          direction.x - worldDir.x < 0.05 &&
          direction.z - worldDir.z > -0.05 &&
          direction.z - worldDir.z < 0.05
        )
      ) {
        handrail.rotation.y += worldDir.angleTo(direction);
      }
    }

    handrail.rotation.z -= Math.atan(7 / 9); //(firstPoint.y - SecondPoint.y) / horizonalDistance);

    handrail.position.add(correctionPositionHorizontal);
    this.railingColorsService.setExistingColor(handrail, 'Top Rail');
    handrail.children.forEach(el => {
      if (el.name === 'TopCap') {
        this.railingColorsService.setExistingColor(handrail, 'Top Cap');
      }
    });
    this.stage.add(handrail);

    this.infills.push(handrail);
    handrail.children.forEach(ch => (ch.castShadow = true));

    if (FirstPoint.isInsideCorner && this.intermediatePostOffset > 0) {
      firstPoint = FirstPoint.clone();
      firstPoint.y = secondPoint.y;
      horizontalDistance = firstPoint.distanceTo(secondPoint);
      firstPoint.y += (horizontalDistance * 7) / 9;
    }

    //BASERAIL

    if (this.currentParams.infill !== 'horizontalCable') {
      this.baserail = this.railingComponent.baserail;
      this.baserailMaterial = this.railingComponent.baserail.children[0].material.clone();
      const baserail = this.cloneObject3DMaterialAndGeometry(this.baserail, this.baserailMaterial);
      baserail.name = 'BaseRailContainer';
      const verticalOffset = 6;
      baserail.position.set(
        firstPoint.x / 2 + secondPoint.x / 2,
        firstPoint.y / 2 +
        secondPoint.y / 2 +
        baserail.userData.entity.placementHeight +
        baserail.userData.entity.height / 2 +
        verticalOffset,
        firstPoint.z / 2 + secondPoint.z / 2
      );
      direction = new THREE.Vector3(secondPoint.x - firstPoint.x, 0, secondPoint.z - firstPoint.z);
      direction = new THREE.Vector3(-direction.z, 0, direction.x);
      direction.setLength(1);
      // baserail.scale.x = (firstPoint.distanceTo(secondPoint)) / baserail.userData.entity.length;

      baserail.userData = { start, end, isLeft, nonHorizontal: true, ...baserail.userData };

      result.push({
        startPoint: FirstPoint.clone(),
        endPoint: secondPoint.clone(),
        rail: baserail,
        verticalPosition: 'Bottom',
        isHorizontal: false
      });

      scaleX = (firstPoint.distanceTo(secondPoint) - postWidth) / baserail.userData.entity.length;
      baserail.children.forEach(c => {
        if (c) {
          c.matrix.makeScale(scaleX, 1, 1);
          c.geometry.applyMatrix(c.matrix);
          this.addAngleToHandrail(c, -morphAngle, morphAngle);
        }
      });

      for (let i = 0; i < 3; i++) {
        const worldDir = baserail.getWorldDirection(new THREE.Vector3());
        if (
          !(
            direction.x - worldDir.x > -0.05 &&
            direction.x - worldDir.x < 0.05 &&
            direction.z - worldDir.z > -0.05 &&
            direction.z - worldDir.z < 0.05
          )
        ) {
          baserail.rotation.y += worldDir.angleTo(direction);
        }
      }

      horizonalDistance = Math.pow(
        Math.pow(firstPoint.x - secondPoint.x, 2) + Math.pow(firstPoint.z - secondPoint.z, 2),
        1 / 2
      );
      baserail.rotation.z -= Math.atan((firstPoint.y - secondPoint.y) / horizonalDistance);

      const correctionPositionVertical = new THREE.Vector3(0, 1, 0);
      correctionPositionVertical.setLength((correctionPositionHorizontal.length() * 7) / 9);
      baserail.position.add(correctionPositionVertical);
      this.railingColorsService.setExistingColor(baserail, 'Bottom Rail');
      this.stage.add(baserail);

      this.infills.push(baserail);
      baserail.children.forEach(ch => (ch.castShadow = true));
    }

    //STAIR HANDRAIL

    if (this.currentParams.stairHandrail !== '' && this.currentParams.stairHandrail !== 'top150') {
      const stairHandrailCenter = this.stairHandrailCenterLeft.clone();
      const stairHandrailTopData = this.getHandrailTopForBusiness(isTopStairPart, isLeft);
      const stairHandrailBottomData = this.getHandrailBottomForBusiness(isTopStairPart, isLeft);
      let stairHandrailTop = stairHandrailTopData.handrailTop;
      let stairHandrailBottom = stairHandrailBottomData.handrailBottom;
      let stairHandrailResidentialTop = this.stairHandrailResidentialTopRight.clone();
      let stairHandrailResidentialBottom = this.stairHandrailResidentialBottomRight.clone();
      if (isTopStairPart === undefined) {
        stairHandrailTopData.isResidental = this.projectType === 'business' ? false : true;
        stairHandrailBottomData.isResidental = this.projectType === 'business' ? false : true;
        stairHandrailTop = isLeft
          ? this.stairHandrailTopLeft.clone()
          : this.stairHandrailTopRight.clone();
        stairHandrailBottom = isLeft
          ? this.stairHandrailBottomLeft.clone()
          : this.stairHandrailBottomRight.clone();
      }
      if (isLeft) {
        stairHandrailOffsetVector.negate();
        stairHandrailResidentialTop = this.stairHandrailResidentialTopLeft.clone();
        stairHandrailResidentialBottom = this.stairHandrailResidentialBottomLeft.clone();
      }

      correctionPositionHorizontal = new THREE.Vector3(
        secondPoint.x - firstPoint.x,
        0,
        secondPoint.z - firstPoint.z
      );
      correctionPositionHorizontal.setLength(
        Math.min(
          stairHandrailCenter.userData.entity.width / 2 - 1.8,
          this.intermediatePost.userData.entity.length / 2
        )
      );

      stairHandrailCenter.position.set(
        firstPoint.x / 2 + secondPoint.x / 2,
        firstPoint.y / 2 +
        secondPoint.y / 2 +
        this.sizeHelper.INCHToCM(
          36
        ) /*stairHandrailCenter.userData.entity.placementHeight + stairHandrailCenter.userData.entity.height / 2 + this.sizeHelper.INCHToCM(+this.intermediatePost.userData.entity.heightGroup - 36)*/,
        firstPoint.z / 2 + secondPoint.z / 2
      );

      // stairHandrailCenter.scale.z = firstPoint.distanceTo(secondPoint) / stairHandrailCenter.userData.entity.length;
      stairHandrailCenter.scale.z =
        (firstPoint.distanceTo(secondPoint) - 2) / stairHandrailCenter.userData.entity.length;
      // if (isStraight && this.projectType === "business") {
      // }

      horizonalDistance = Math.pow(
        Math.pow(firstPoint.x - secondPoint.x, 2) + Math.pow(firstPoint.z - secondPoint.z, 2),
        1 / 2
      );
      const stairAngle = Math.atan((firstPoint.y - secondPoint.y) / horizonalDistance);

      direction = new THREE.Vector3(secondPoint.x - firstPoint.x, 0, secondPoint.z - firstPoint.z);

      const norm = new THREE.Vector3(0, 0, 1);
      let angle = direction.angleTo(norm);
      if (direction.x < 0) {
        angle = -direction.angleTo(norm);
      }
      stairHandrailCenter.rotateY(angle);

      stairHandrailCenter.rotateOnWorldAxis(
        stairHandrailOffsetVector.clone().normalize(),
        isLeft ? stairAngle : -stairAngle
      );

      stairHandrailCenter.position.add(stairHandrailOffsetVector);
      this.stage.add(stairHandrailCenter);

      this.infills.push(stairHandrailCenter);

      stairHandrailCenter.children.forEach(ch => (ch.castShadow = true));
      let offsetBusiness = 5;
      if (!stairHandrailTopData.isResidental) {
        stairHandrailTop.position.set(
          firstPoint.x,
          firstPoint.y +
          this.sizeHelper.INCHToCM(36) -
          stairHandrailTop.userData.entity.height / 2 +
          0.8 /*+ stairHandrailTop.userData.entity.placementHeight + this.sizeHelper.INCHToCM(+this.intermediatePost.userData.entity.heightGroup - 36)*/,
          firstPoint.z
        );
        const offsetTop = new THREE.Vector3(
          firstPoint.x - secondPoint.x,
          0,
          firstPoint.z - secondPoint.z
        );
        offsetTop.setLength(20);
        stairHandrailTop.position.add(offsetTop);
        stairHandrailTop.rotateY(angle);
        correctionPositionHorizontal.setLength(
          correctionPositionHorizontal.length() + offsetBusiness
        );
        stairHandrailTop.position.add(correctionPositionHorizontal);
        stairHandrailOffsetVector.setLength(stairHandrailTopOffset);
        stairHandrailTop.position.add(stairHandrailOffsetVector);
        this.stage.add(stairHandrailTop);
        this.infills.push(stairHandrailTop);
        offsetBusiness = 0;
      }
      if (!stairHandrailBottomData.isResidental) {
        stairHandrailBottom.position.set(
          secondPoint.x,
          secondPoint.y +
          this.sizeHelper.INCHToCM(36) -
          stairHandrailBottom.userData.entity.height / 2 +
          3 /*+ stairHandrailBottom.userData.entity.placementHeight + this.sizeHelper.INCHToCM(+this.intermediatePost.userData.entity.heightGroup - 36)*/,
          secondPoint.z
        );

        const offsetBottom = new THREE.Vector3(
          secondPoint.x - firstPoint.x,
          0,
          secondPoint.z - firstPoint.z
        );
        offsetBottom.setLength(6.7);
        stairHandrailBottom.position.add(offsetBottom);
        stairHandrailBottom.rotateY(angle);
        correctionPositionHorizontal.setLength(
          correctionPositionHorizontal.length() + 3.6 + offsetBusiness
        );
        stairHandrailBottom.position.add(correctionPositionHorizontal);
        stairHandrailOffsetVector.setLength(stairHandrailTopOffset);
        stairHandrailBottom.position.add(stairHandrailOffsetVector);
        this.stage.add(stairHandrailBottom);
        this.infills.push(stairHandrailBottom);
        stairHandrailBottom.children.forEach(ch => (ch.castShadow = true));
      }
      if (stairHandrailTopData.isResidental) {
        stairHandrailResidentialTop.position.set(
          firstPoint.x,
          firstPoint.y +
          this.sizeHelper.INCHToCM(
            36
          ) /*stairHandrailResidentialTop.userData.entity.placementHeight + this.sizeHelper.INCHToCM(+this.intermediatePost.userData.entity.heightGroup - 36)*/,
          firstPoint.z
        );
        stairHandrailResidentialTop.rotateY(angle);
        stairHandrailResidentialTop.rotateOnWorldAxis(
          stairHandrailOffsetVector.clone().normalize(),
          isLeft ? stairAngle : -stairAngle
        );
        correctionPositionHorizontal.y = (-correctionPositionHorizontal.length() * 7) / 9;
        correctionPositionHorizontal.setLength(
          stairHandrailResidentialTop.userData.entity.length / 2 - 2
        );
        stairHandrailResidentialTop.position.add(correctionPositionHorizontal);

        stairHandrailOffsetVector.setLength(stairHandrailTopOffset);
        stairHandrailResidentialTop.position.add(stairHandrailOffsetVector);
        stairHandrailResidentialBottom.position.add(stairHandrailOffsetVector);

        this.stage.add(stairHandrailResidentialTop);

        this.infills.push(stairHandrailResidentialTop);
        this.infills.push(stairHandrailResidentialBottom);

        stairHandrailResidentialTop.children.forEach(ch => (ch.castShadow = true));
        stairHandrailResidentialBottom.children.forEach(ch => (ch.castShadow = true));
      }
      if (stairHandrailBottomData.isResidental) {
        stairHandrailResidentialBottom.position.set(
          secondPoint.x,
          secondPoint.y +
          this.sizeHelper.INCHToCM(
            36
          ) /*stairHandrailResidentialBottom.userData.entity.placementHeight + this.sizeHelper.INCHToCM(+this.intermediatePost.userData.entity.heightGroup - 36)*/,
          secondPoint.z
        );
        stairHandrailResidentialBottom.rotateY(angle);
        stairHandrailResidentialBottom.rotateOnWorldAxis(
          stairHandrailOffsetVector.clone().normalize(),
          isLeft ? stairAngle : -stairAngle
        );
        if (this.projectType === 'business') {
          correctionPositionHorizontal.y = (-correctionPositionHorizontal.length() * 7) / 9;
        }
        correctionPositionHorizontal.setLength(
          stairHandrailResidentialTop.userData.entity.length / 2 - 2
        );
        correctionPositionHorizontal.negate();
        stairHandrailResidentialBottom.position.add(correctionPositionHorizontal);
        stairHandrailOffsetVector.setLength(stairHandrailTopOffset);
        stairHandrailResidentialBottom.position.add(stairHandrailOffsetVector);
        this.stage.add(stairHandrailResidentialBottom);
        this.infills.push(stairHandrailResidentialBottom);
        stairHandrailResidentialBottom.children.forEach(ch => (ch.castShadow = true));
      }

      this.railingColorsService.setExistingColor(stairHandrailCenter, 'Stair Handrail');
      this.railingColorsService.setExistingColor(stairHandrailTop, 'Stair Handrail');
      this.railingColorsService.setExistingColor(stairHandrailResidentialTop, 'Stair Handrail');
      this.railingColorsService.setExistingColor(stairHandrailResidentialBottom, 'Stair Handrail');
      this.railingColorsService.setExistingColor(stairHandrailBottom, 'Stair Handrail');
    }

    return result;
  }

  getHandrailTopForBusiness(isTopStairPart, isLeft) {
    if (this.projectType === 'business') {
      if (isTopStairPart) {
        const handrailTop = isLeft
          ? this.stairHandrailTopLeft.clone()
          : this.stairHandrailTopRight.clone();
        const isResidental = false;
        return {
          handrailTop: handrailTop,
          isResidental: isResidental
        };
      } else {
        const handrailTop = isLeft
          ? this.stairHandrailResidentialTopLeft.clone()
          : this.stairHandrailResidentialTopRight.clone();
        const isResidental = true;
        return {
          handrailTop: handrailTop,
          isResidental: isResidental
        };
      }
    } else {
      const handrailTop = isLeft
        ? this.stairHandrailResidentialTopLeft.clone()
        : this.stairHandrailResidentialTopRight.clone();
      const isResidental = true;
      return {
        handrailTop: handrailTop,
        isResidental: isResidental
      };
    }
  }

  getHandrailBottomForBusiness(isTopStairPart, isLeft) {
    if (this.projectType === 'business') {
      if (isTopStairPart) {
        const handrailBottom = isLeft
          ? this.stairHandrailResidentialBottomLeft.clone()
          : this.stairHandrailResidentialBottomRight.clone();
        const isResidental = true;
        return {
          handrailBottom: handrailBottom,
          isResidental: isResidental
        };
      } else {
        const handrailBottom = isLeft
          ? this.stairHandrailBottomLeft.clone()
          : this.stairHandrailBottomRight.clone();
        const isResidental = false;
        return {
          handrailBottom: handrailBottom,
          isResidental: isResidental
        };
      }
    } else {
      const handrailBottom = isLeft
        ? this.stairHandrailResidentialBottomLeft.clone()
        : this.stairHandrailResidentialBottomRight.clone();
      const isResidental = true;
      return {
        handrailBottom: handrailBottom,
        isResidental: isResidental
      };
    }
  }

  updateCurrentParams() {
    this.currentParams = this.dataForMenu.getCurrentParams();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/post/services/railing-posts-for-stairs.service.ts